<template>
    <div class="course-channel">
        <div v-if="is_mobile">
            <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no">
        </div>
        <el-dialog title="选择操作" :visible.sync="dialogVisible" :width="is_mobile?'80%':'30%'">
            <button class="dialog_btn" data-time="2" @click="click_dialog_btn($event)">左 置 顶</button>
            <button class="dialog_btn" data-time="1" @click="click_dialog_btn($event)">右 置 顶</button>
            <button class="dialog_btn" v-if="is_temp_user_forbidden" @click="set_user_forbidden">解除禁言</button>
            <button class="dialog_btn" v-if="!is_temp_user_forbidden" @click="set_user_forbidden">禁 言</button>
            <button class="dialog_btn" data-time="-1" @click="click_dialog_btn($event)">删 除</button>
            <button class="dialog_btn" data-time="0" @click="click_dialog_btn($event)">取 消</button>
        </el-dialog>
        <el-dialog title="修改/删除信息" :visible.sync="messageDialogVisible" :width="is_mobile?'80%':'50%'" id="change_message_dialog">
            <div class="dialog_input_div">
                <textarea maxlength="1000" class="dialog_text" v-model="temp_change_message"></textarea>
                <div>
                    <button class="dialog_btn" @click="change_message_dialog_btn(false)">确认修改</button>
                    <button class="dialog_btn" @click="change_message_dialog_btn(true)">左右互换</button>
                    <button class="dialog_btn" @click="delete_up_message()">撤销精选</button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="修改主题信息" :visible.sync="subjectNameDialogVisible" :width="is_mobile?'80%':'50%'">
            <div class="dialog_input_div">
                <textarea maxlength="1000" class="dialog_text_small" v-model="temp_subject_name"></textarea>
                <textarea maxlength="1000" class="dialog_text_small" v-model="temp_subject_content"></textarea>
                <div>
                    <button class="dialog_btn" @click="subject_name_dialog_btn()">确认修改</button>
                    <button class="dialog_btn" @click="delete_subject()">删除主题</button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="修改公告" :visible.sync="noteDialogVisible" :width="is_mobile?'80%':'50%'">
            <div class="dialog_input_div">
                <textarea maxlength="1000" class="dialog_text" v-model="note_info"></textarea>
                <div>
                    <button class="dialog_btn" @click="change_note_info()">确认修改</button>
                    <button class="dialog_btn" @click="cancel_click_note()">取消</button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="查看图片" :visible.sync="imgDialogVisible" :width="temp_img_width">
            <div class="dialog_input_div" v-html="imgShow">

            </div>
        </el-dialog>
        <el-dialog title="创建新主题" :visible.sync="newSubjectDialogVisible" :width="is_mobile?'80%':'50%'">
            <div class="dialog_input_div">
                <textarea maxlength="1000" class="dialog_text_small" v-model="temp_subject_name"></textarea>
                <textarea maxlength="1000" class="dialog_text_small" v-model="temp_subject_content"></textarea>
                <div>
                    <button class="dialog_btn" @click="add_page_with_edit(true)">新建</button>
                    <button class="dialog_btn" @click="clean_temp_info">清空</button>
                    <button class="dialog_btn" @click="add_page_with_edit(false)">取消</button>
                </div>
            </div>
        </el-dialog>
        <div id="login-mask" v-if="!sign_on" class='welcome-box'>
            <div class="welcome">
                <div class="text">验证失败，请登陆后重试</div>
                <div class="btn"><span @click="open_login_page()">点击登陆</span></div>
            </div>
        </div>
        <div id="re-login-mask" v-if="let_relogin" class='welcome-box'>
            <div class="welcome">
                <div class="text">请重新登录...</div>
                <div class="btn"><span @click="open_login_page()">点击登陆</span></div>
            </div>
        </div>
        <div id="wait-mask" v-if="sign_on && is_init && !let_relogin" class='welcome-box'>
            <div class="welcome">
                <div class="text">系统连接中，请稍候...</div>
            </div>
        </div>
        <div id="closed-mask" v-if="!is_init && sign_on && channel_info && channel_info !== {} && !channel_info.is_symposium_opened && !is_course_end && !is_bad_connect && !let_relogin" class='welcome-box'>
            <div class="welcome">
                <div class="text">研讨课程尚未开始上课。</div>
                <div class="btn" v-if="is_teacher" @click="enter_symposium(true)"><span>老师进入</span></div>
                <div class="btn" v-else><span>请稍后再试</span></div>
            </div>
        </div>
        <div id="enter-mask" v-if="!is_repeat && !is_init && sign_on && channel_info && channel_info!== {} && channel_info.is_symposium_opened && show_enter_mask && !is_course_end && !is_bad_connect && !let_relogin"
             class='welcome-box'>
            <div class="welcome">
                <div class="text">欢迎加入佑佐研讨课程{{ enter_mask_state }}</div>
                <div v-if="!is_enter_clicked" class="btn" @click="enter_symposium()"><span>点击进入</span></div>
            </div>
        </div>
        <div id="enter-repeat-mask" v-if="is_repeat && !is_init && sign_on && channel_info && channel_info.is_symposium_opened && show_enter_mask && !is_course_end && !is_bad_connect && !let_relogin"
             class='welcome-box'>
            <div class="welcome">
                <div class="text">账号已在其他设备中登录</div>
                <div class="btn" @click="still_login()"><span>继续登录</span></div>
            </div>
        </div>
        <div id="not-open-mask" v-if="!is_init && sign_on && is_course_end && !is_back_play && !is_bad_connect && channel_info && !let_relogin" class='welcome-box'>
            <div class="welcome">
                <div v-if="(!is_enter_clicked && is_buy) || is_teacher" class="text">课后回看</div>
                <div v-if="!is_buy && !is_teacher" class="text">课程结束</div>
                <div v-if="(!is_enter_clicked && is_buy) || is_teacher" class="btn" @click="enter_symposium_back_play()"><span>进入回看</span></div>
            </div>
        </div>
        <div id="bad-connect-mask" v-if="sign_on && !is_init && (is_bad_connect || !channel_info) && !let_relogin" class='welcome-box'>
            <div class="welcome">
                <div class="text">连接失败，请稍候重试...</div>
                <div class="btn" @click="reload()"><span>刷新页面</span></div>
            </div>
        </div>
        <div id="exit-mask" v-if="!is_init && channel_info && 0" class='welcome-box'>
            <div class="welcome">
                <div class="text">连接中断，请稍候重试...</div>
                <div class="btn" @click="enter_symposium()"><span>重新进入</span></div>
            </div>
        </div>
        <div id="course-learn-box" class="course-learn" v-if="!is_mobile && !chat_mode">
            <div class="m-courselearn">
                <div class="course_header_bar_div show_course_header" :style="bg_color" v-if="channel_info">
                    <div class="course_header_bar_layout_div">
                        <div style="cursor: pointer" class="course_header_bar_course_info_top" @click="click_quit">
                            <span v-if="channel_info && channel_info.course_info"
                                  class="course_header_bar_course_title ellipsis">{{ channel_info.course_info.name }}</span>
                        </div>
                        <div class="course_header_bar_course_info_bottom">
                            <span v-if="channel_info && channel_info.lesson_info"> ● {{ channel_info.lesson_info.name }} </span>
                            <span v-if="channel_info && channel_info.master_info"
                                  class="span_split">主讲: {{ channel_info.master_info.real_name }} </span>
                            <span v-if="channel_info.course_students_count>=10"
                                  class="span_split">{{ channel_info.course_info.students_count }} 人学过 </span>
                            <span v-if="channel_info.course_followers_count>=10"
                                  class="span_split">{{ channel_info.course_info.followers_count }} 人收藏</span>
                        </div>
                    </div>
                    <div class="course_header_bar_layout_right_div">
                        <el-dropdown v-if="is_teacher" style="float:right;padding-right:10px">
                            <span class="el-dropdown-link"
                                  style="color:white;font-size: small">
                              <i class="el-icon-menu" style="font-size: 30px"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>
                                    <span @click="start_or_end_symposium('start')">上课</span>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <span @click="start_or_end_symposium('end')">下课</span>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                    <span :style="is_symposium_opened?'color: green':'color:red'">{{is_symposium_opened?'已开课':'未开课'}}</span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="learn-total">
                    <div id="lesson-learn-box" class="learn-box">
                        <div class="m-text-box">
                            <div class="j-textbox">
                                <div class="ux-cl-reader">
                                    <!--Regular if95-->
                                    <div class="ux-h5clreader">
                                        <div class="ux-h5clreader_container">
                                            <div class="ux-h5clreader_container_viewer">
                                                <div class="ux-h5clreader_container_viewer_wrap" v-if="active_page.subject_name">
                                                    <div style="cursor: pointer" class="active-page-subject"
                                                         @click="is_teacher?change_subject_name_dialog_on():''">
                                                        <div class="text">{{ active_page.subject_name }}<img src="/static/img/bg_edit.png"
                                                                                                             v-if="is_teacher"></div>
                                                        <div class="tips">{{ active_page_index }}/{{ channel_subjects.length }}</div>
                                                    </div>
                                                    <div class="ux-edu-clviewer f-pa j-body">
                                                        <div class="ux-edu-main">
                                                            <div style="cursor: pointer" v-if="active_page" class="active-page-content"
                                                                 @click="is_teacher?change_subject_name_dialog_on():''">
                                                                <span>{{ active_page.content }}</span></div>
                                                            <div class="left-viewpoint">
                                                                <ul v-if="channel_info.teacher">
                                                                    <li v-for="message in active_page.m_ids" :key="message.outer_id"
                                                                        v-if="message.is_left">
                                                                        <div :class="is_teacher?'viewpoint-item is-teacher':'viewpoint-item'">
                                                                            <div class="left-viewpoint-item">
                                                                                <viewer v-if="!is_teacher">
                                                                                    <div v-html="message.message.trim()" @click="is_teacher?change_message_dialog_on(message):''">
                                                                                        <!--{{ message.message.trim() }}-->
                                                                                        <img class="img_item"  src="/static/img/bg_edit.png" v-if="is_teacher">
                                                                                    </div>
                                                                                </viewer>
                                                                                <div v-else v-html="message.message.trim()" @click="is_teacher?change_message_dialog_on(message):''">
                                                                                    <!--{{ message.message.trim() }}-->
                                                                                    <img class="img_item"  src="/static/img/bg_edit.png" v-if="is_teacher">
                                                                                </div>
                                                                            </div>
                                                                            <img class="viewpoint-avatar" :src="message['user']['avatar_url']">
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="ux-edu-stick">
                                                            <div class="left-viewpoint">
                                                                <ul v-if="channel_info.teacher">
                                                                    <li v-for="message in active_page.m_ids" :key="message.outer_id"
                                                                        v-if="!message.is_left">
                                                                        <div :class="is_teacher?'viewpoint-item is-teacher':'viewpoint-item'">
                                                                            <div class="left-viewpoint-item">
                                                                                <viewer v-if="!is_teacher">
                                                                                    <div v-html="message.message.trim()" @click="is_teacher?change_message_dialog_on(message):''">
                                                                                        <!--{{ message.message }}-->
                                                                                        <img class="img_item" src="/static/img/bg_edit.png" v-if="is_teacher">
                                                                                    </div>
                                                                                </viewer>
                                                                                <div v-else v-html="message.message.trim()" @click="is_teacher?change_message_dialog_on(message):''">
                                                                                    <!--{{ message.message }}-->
                                                                                    <img class="img_item" src="/static/img/bg_edit.png" v-if="is_teacher">
                                                                                </div>
                                                                            </div>
                                                                            <img class="viewpoint-avatar" :src="message['user']['avatar_url']">
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <div class="active-page-subject">
                                                        <div class="text">在线研讨课程</div>
                                                        <div class="tips">{{ active_page_index }}/{{ channel_subjects.length }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <a v-if="show_slide_bigarrow" class="ux-h5clreader_container_bigprev"></a>
                                            <a v-if="show_slide_bigarrow" class="ux-h5clreader_container_bignext"></a>

                                            <div class="ux-h5clreader_container_footer" v-if="is_teacher|| is_course_end">

                                                <div class="ux-h5clreader_container_footer_pages">
                                                    <a class="page_prev" @click="change_subject('prev')"><i/>上一页</a>
                                                    <div>
                                                        <a class="ux-h5clreader_container_footer_pages_change" style="width:120px">
                                                            <el-dropdown trigger="click">
                                                            <span class="el-dropdown-link" style="color:white;font-size: small">
                                                              所有主题页面<i class="el-icon-arrow-down el-icon--right"></i>
                                                            </span>
                                                                <el-dropdown-menu slot="dropdown">
                                                                    <el-dropdown-item v-for="(subject, index) in channel_subjects" :key="index"
                                                                                      @click.native="change_subject_by_select(subject)">{{index + 1}}
                                                                        {{subject['name']}}
                                                                    </el-dropdown-item>
                                                                </el-dropdown-menu>
                                                            </el-dropdown>
                                                        </a>
                                                    </div>
                                                    <!--<a class="page_list">所有主题页面</a>-->
                                                    <!--<input class="ux-h5clreader_container_footer_pages_in" @change="change_subject_by_page_index($event)">
                                                    <span class="ux-h5clreader_container_footer_pages_total">{{ active_page_index }}/{{ channel_subjects.length }}</span>-->
                                                    <a v-if="is_teacher" class="page_add" @click="add_page_with_edit_dialog_on"><i/>新页面</a>
                                                    <a class="page_next" @click="change_subject('next')"><i/>下一页</a>

                                                </div>
                                                <a class="ux-h5clreader_container_footer_scalebigger"></a>
                                                <a class="ux-h5clreader_container_footer_scalesmaller"></a>

                                                <!--Regular if97-->
                                                <a class="ux-h5clreader_container_footer_enterfull"></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="course-tool-box" class="course-tool" :style="is_mobile || chat_mode?'width: 100%;':'width: 33%;'">
            <div class="m-ctb">
                <div class="courseintro">
                    <div class="f-fl courseTitle j-courseintro">
                        <div class="u-coursetitle f-fl" v-if="is_mobile">
                            <a v-if="channel_info.course_info" class="f-thide" @click="click_quit">课程：{{channel_info.course_info.name}}</a>
                            <div class="f-cb">
                                <span v-if="active_page" class="active_page_subject">主题：{{active_page.subject_name}}</span>
                            </div>
                        </div>
                        <div class="u-coursetitle f-fl" v-else>
                            <a v-if="channel_info.master_info" class="f-thide" @click="click_quit">导师：{{channel_info.master_info.real_name}}</a>
                            <div class="f-cb">
                                <span v-if="channel_info.master_info && channel_info.master_info.honor" class="active_page_subject">{{channel_info.master_info.honor}}</span>
                            </div>
                            <p v-if="channel_info.master_info" class="j-info">共发表过{{ channel_info.master_info.published_courses_count }}门课程</p>
                        </div>
                    </div>
                    <div class="item_header">
                        <img :src="channel_info.master_info ? channel_info.master_info.avatar_url : '/static/img/logox.png'" class="avatar">
                        <div v-if="channel_info.master_info" class="name f-thide-small-font">{{ channel_info.master_info.real_name }}</div>
                    </div>
                    <div class="icon-chat-mode" @click="click_switch_chat_mode()" v-if="!is_mobile">
                        <img src='/static/img/to_left.png' v-if="chat_mode">
                        <img src='/static/img/to_right.png' v-else>
                    </div>
                </div>
                <div class="tabs j-tab-tabwrap">
                    <a :class="show_tabbox=='intro' ? 'tabitem active':'tabitem'" @click="click_show_tabbox('intro')">
                        <span class="f-fl tabicon tabicon-0"></span><span class="f-fl">公告</span></a>
                    <a :class="show_tabbox=='forum' ? 'tabitem active':'tabitem'" @click="click_show_tabbox('forum')">
                        <span class="f-fl tabicon tabicon-1"></span><span class="f-fl">研讨</span></a>
                    <a :class="show_tabbox=='stick' ? 'tabitem active':'tabitem'" @click="click_show_tabbox('stick')">
                        <span class="f-fl tabicon tabicon-2"></span><span class="f-fl">精选</span></a>
                    <a :class="show_tabbox=='qanda' ? 'tabitem active':'tabitem'" @click="click_show_tabbox('qanda')" style="display:none;">
                        <span class="f-fl tabicon tabicon-3"></span><span class="f-fl">问答</span></a>
                    <a :class="show_tabbox=='notes' ? 'tabitem active':'tabitem'" @click="click_show_tabbox('notes')" style="display:none;">
                        <span class="f-fl tabicon tabicon-4"></span><span class="f-fl">笔记</span></a>
                </div>
                <div id="toolbar-box" class="tabarea j-tabarea">
                    <div class="tabbox j-tabbox" style="display: block;" v-if="show_tabbox=='intro'">
                        <div class="m-toolbar-forum">
                            <div class="posts-intro">
                                <ul class="message_box">
                                    <li class="item significant_kanban">
                                        <div class="intro_content" @click="is_teacher?click_note_dialog():''">
                                            <div v-if="channel_info.lesson_info.description">
                                                <span>{{channel_info.lesson_info.description}}</span>
                                            </div>
                                            <div v-else>暂无公告</div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="bullet-container">
                                <vue-baberrage :isShow="barrageIsShow" :barrageList="barrageList" :loop="barrageLoop">
                                </vue-baberrage>
                                <div class="button_area">
                                    <span v-if="!channel_info.is_symposium_opened">未开课</span>
                                    <span v-if="channel_info.is_symposium_opened && channel_info.course_info.teacher == channel_info.user_info.id"> {{ channel_users.length }} 人在线</span>
                                    <div style="display: inline-block;" v-if="this.is_course_end && !this.is_teacher && !is_back_play_end">
                                        <img v-if="is_back_play_playing" class="player-icon" src='/static/img/symposium_stop.png' @click="back_play_stop()">
                                        <img v-else class="player-icon" src='/static/img/symposium_play.png' @click="back_play_play()">
                                        <img class="player-icon" src='/static/img/symposium_faster.png' @click="back_play_faster()">
                                        <img class="player-icon" src='/static/img/symposium_end.png' @click="back_play_end()">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tabbox j-tabbox" style="display: block;" v-if="show_tabbox=='forum'">
                        <div class="m-toolbar-forum">
                            <div :class="is_emoji_show?'posts-forum_emoji':'posts-forum'">
                                <ul id="forum-scroll-div" class="message_box" v-if="channel_info.user_info">
                                    <li class="item significant_kanban" v-for="message in channel_messages" :key="message.outer_id">
                                        <!--自己的发言，头像放在右边，其他人的发言头像在左边-->
                                        <div v-if="message['user_info']['user_id'] === channel_info.user_info.id">
                                            <div class="item_header_self">
                                                <img class="avatar" :src="message['user_info']['avatar_url']">
                                                <div class="name f-thide-small-font">{{ message['user_info']['name'] }}</div>
                                            </div>
                                            <div style="cursor: pointer" class="item_content_self" @click="click_raise_btn($event, message)">
                                                <div>
                                                    <img src="/static/img/bg_chat_r.png" class="item_side_img_right">
                                                    <div v-html="message.message"></div>
                                                    <!--{{ message.message }}-->
                                                    <img src="/static/img/star_badge.png" class="item-stick-act right">
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="item_header">
                                                <img class="avatar" :src="message['user_info']['avatar_url']">
                                                <div class="name f-thide-small-font">{{ message['user_info']['name'] }}</div>
                                            </div>
                                            <div>
                                                <div style="cursor: pointer" class="item_content" @click="click_raise_btn($event, message)"
                                                     :style="channel_info.teacher && channel_info.teacher.includes(Number(message['user_info']['user_id']))?
                                                     'font-weight: bolder;color:#3B200C':'color:#3B200C'">
                                                    <div>
                                                        <img src="/static/img/bg_chat_l.png" class="item_side_img_left">
                                                        <viewer v-if="!is_teacher">
                                                            <div v-html="message.message"></div>
                                                        </viewer>
                                                        <div v-else v-html="message.message"></div>
                                                        <!--{{ message.message }}-->
                                                        <img src="/static/img/star_badge.png" class="item-stick-act left">
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="is_emoji_show">
                                <span class="icon_slot" v-for="(icon, icon_index) in emoji_list" :key="icon_index" @click="add_emoji_to_input(icon)">{{icon}}</span>

                            </div>
                            <div class="edit f-cb">
                                <div :class="forbidden?'not_show':'input_area'" v-if="!this.is_course_end || this.is_teacher">
                                    <textarea id="input_area" placeholder="请在此输入，点击ctrl+回车发送..." placeholder-class="place-holder" maxlength="1000"
                                              v-if="channel_info.is_symposium_opened"
                                              class="test_area" v-model="inputting_words"
                                              @focus="focus_input()"
                                              v-on:keyup.ctrl.13="websocketsend()"></textarea>
                                    <textarea v-else class="test_area" v-model="inputting_words"></textarea>
                                    <!--<input type="text" class="form-control" v-model="inputting_words">-->
                                    <!--<button v-if="is_symposium_opened && !forbidden" class="btn_sym" @click="websocketsend()">发送</button>-->
                                </div>
                                <div :class="forbidden?'input_area':'not_show'">
                                    <p style="color: red">您已被管理员禁言</p>
                                </div>
                                <div class="button_area">
                                    <span v-if="!channel_info.is_symposium_opened">未开课</span>
                                    <span v-if="channel_info.is_symposium_opened && channel_info.course_info.teacher == channel_info.user_info.id"> {{ channel_users.length }} 人在线</span>
                                    <div style="display: inline-block;" v-if="this.is_course_end && !this.is_teacher && !is_back_play_end">
                                        <img v-if="is_back_play_playing" class="player-icon" src='/static/img/symposium_stop.png' @click="back_play_stop()">
                                        <img v-else class="player-icon" src='/static/img/symposium_play.png' @click="back_play_play()">
                                        <img class="player-icon" src='/static/img/symposium_faster.png' @click="back_play_faster()">
                                        <img class="player-icon" src='/static/img/symposium_end.png' @click="back_play_end()">
                                    </div>
                                    <a v-if="channel_info.is_symposium_opened && !forbidden && (!this.is_course_end || this.is_teacher)" class="j-post postBtn f-fr"
                                       @click="websocketsend()"><span>发送</span></a>
                                    <a title="表情" v-if="channel_info.is_symposium_opened && !forbidden && (!this.is_course_end || this.is_teacher)" class="j-post f-fr" style="padding-left: 5px">
                                        <span @click="emoji_icon_enter" class="el-dropdown-link" style="color:white;font-size: small">
                                            <img style="width: 35px;height: 35px" src="/static/img/char_emoji.png">
                                        </span>
                                        <!--<el-dropdown>-->
                                            <!--<span class="el-dropdown-link"-->
                                                  <!--style="color:white;font-size: small">-->
                                                <!--<img style="width: 35px;height: 35px" src="/static/img/char_emoji.png">-->
                                            <!--</span>-->
                                            <!--<el-dropdown-menu slot="dropdown">-->
                                                <!--<div style="width: 300px">-->
                                                    <!--<span class="icon_slot" v-for="(icon, icon_index) in emoji_list" :key="icon_index" @click="add_emoji_to_input(icon)">{{icon}}</span>-->
                                                <!--</div>-->
                                            <!--</el-dropdown-menu>-->
                                        <!--</el-dropdown>-->
                                    </a>
                                    <a title="图片" v-if="channel_info.is_symposium_opened && !forbidden && (!this.is_course_end || this.is_teacher)" class="j-post f-fr" style="display: flex;">
                                        <!--&lt;!&ndash;action="http://vue-odoo.miaochun.net/api/v2/upload_file"&ndash;&gt;-->
                                        <!--<el-upload-->
                                                <!--action="http://localhost:8000/api/v2/upload_file"-->
                                                <!--:show-file-list="false"-->
                                                <!--:on-success="handleUploadSuccess"-->
                                                <!--:before-upload="beforeUpload"-->
                                                <!--:http-request="uploadAction"-->
                                        <!--&gt;-->
                                            <!--<i class="el-icon-picture" style="font-size: 35px"></i>-->
                                        <!--</el-upload>-->
                                        <i v-if="pic_list.length < max_pic_length && (is_teacher || channel_info.invitees.includes(Number(channel_info.user_info.id)))" class="el-icon-plus pic-list-icon" @click="click_input"></i>
                                        <div class="pic-list-div" v-for="(pic,index_pic) in pic_list" :key="index_pic">
                                            <i @click="delete_pic(index_pic)" class="el-icon-close pic-list-del"></i>
                                            <img :src="pic" class="pic-slot">
                                        </div>
                                        <input v-if="is_teacher || channel_info.invitees.includes(Number(channel_info.user_info.id))" id="upload_input" accept="image/*" style="display: none" type="file" @change="uploadAction($event)">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tabbox j-tabbox" style="display: block;" v-if="show_tabbox=='stick'">
                        <div class="m-toolbar-forum">
                            <div id="stick-scroll-div" class="posts-stick">
                                <el-collapse v-model="activeNames">
                                    <el-collapse-item v-for="subject in channel_subjects" :key="subject.id">
                                        <template slot="title">
                                            <div style="width: 90%">
                                                <div style="float:left;padding-left: 10px">
                                                    <span>{{subject.pages[0].subject_name}}</span>
                                                </div>
                                                <div style="float:right">
                                                    <span style="border-radius: 50%;height: 20px;width: 20px;display: inline-block;background: gray;">
                                                        <span style="display: block;color: #FFFFFF;height: 20px;line-height: 20px;text-align: center"> {{subject.pages[0].m_ids.length}}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </template>
                                        <ul class="stick-message-box" v-if="subject.pages[0].m_ids">
                                            <li class="item significant_kanban" v-for="message in subject.pages[0].m_ids" :key="message.outer_id">
                                                <div>
                                                    <div class="item_header">
                                                        <img class="avatar" :src="message['user']['avatar_url']">
                                                        <div class="name f-thide-small-font">{{ message['user']['name'] }}</div>
                                                    </div>
                                                    <div class="item_content" :data-outer-id="message['outer_id']"
                                                         :style="channel_info.invitees && channel_info.invitees.includes(Number(message['user']['id']))?'background-color:#FFFFCC':''">
                                                        <div :data-outer-id="message['outer_id']">
                                                            <img src="/static/img/bg_chat_l.png" class="item_side_img_left">
                                                                <viewer>
                                                                    <div v-html="message.message"></div>
                                                                </viewer>

                                                            <!--{{ message.message }}-->
                                                            <!--<img src="/static/img/star_badge.png" class="item-stick-act left"-->
                                                            <!--style="visibility: visible">-->
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </el-collapse-item>
                                </el-collapse>

                                <!--<div v-for="subject in channel_subjects" :key="subject.id" v-if="channel_info.user_info">-->
                                    <!--<div v-for="page in subject.pages" :key="page.outer_id" v-if="subject.pages">-->
                                        <!--<ul class="stick-message-box" v-if="page.m_ids">-->
                                            <!--<li class="item significant_kanban" v-for="message in page.m_ids" :key="message.outer_id">-->
                                                <!--<div>-->
                                                    <!--<div class="item_header">-->
                                                        <!--<img class="avatar" :src="message['user']['avatar_url']">-->
                                                        <!--<div class="name f-thide-small-font">{{ message['user']['name'] }}</div>-->
                                                    <!--</div>-->
                                                    <!--<div class="item_content" :data-outer-id="message['outer_id']"-->
                                                         <!--:style="channel_info.invitees && channel_info.invitees.includes(Number(message['user']['id']))?'background-color:#FFFFCC':''">-->
                                                        <!--<div :data-outer-id="message['outer_id']">-->
                                                            <!--<img src="/static/img/bg_chat_l.png" class="item_side_img_left">-->
                                                                <!--<viewer>-->
                                                                    <!--<div v-html="message.message"></div>-->
                                                                <!--</viewer>-->

                                                            <!--&lt;!&ndash;{{ message.message }}&ndash;&gt;-->
                                                            <!--&lt;!&ndash;<img src="/static/img/star_badge.png" class="item-stick-act left"&ndash;&gt;-->
                                                            <!--&lt;!&ndash;style="visibility: visible">&ndash;&gt;-->
                                                        <!--</div>-->
                                                    <!--</div>-->
                                                <!--</div>-->
                                            <!--</li>-->
                                        <!--</ul>-->
                                    <!--</div>-->
                                <!--</div>-->
                            </div>
                            <div class="bullet-container">
                                <vue-baberrage :isShow="barrageIsShow" :barrageList="barrageList" :loop="barrageLoop">
                                </vue-baberrage>
                                <div class="button_area">
                                    <span v-if="!channel_info.is_symposium_opened">未开课</span>
                                    <span v-if="channel_info.is_symposium_opened && channel_info.course_info.teacher == channel_info.user_info.id"> {{ channel_users.length }} 人在线</span>
                                    <div style="display: inline-block;" v-if="this.is_course_end && !this.is_teacher && !is_back_play_end">
                                        <img v-if="is_back_play_playing" class="player-icon" src='/static/img/symposium_stop.png' @click="back_play_stop()">
                                        <img v-else class="player-icon" src='/static/img/symposium_play.png' @click="back_play_play()">
                                        <img class="player-icon" src='/static/img/symposium_faster.png' @click="back_play_faster()">
                                        <img class="player-icon" src='/static/img/symposium_end.png' @click="back_play_end()">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import cookies from 'vue-cookies';
    import {mapState, mapActions} from 'vuex';
    import channelApi from '@/api/channel/channel.js';
    import Upload from '@/api/upload/upload.js'
    import wx from 'weixin-js-sdk';
    // import wxApi from 'apifm-wxapi';
    import {MESSAGE_TYPE} from '@/assets/js/vue-baberrage.js';
    export default {
        components: {

        },
        data() {
            return {
                //todo 前进后退控制，后续回放时学员可用（暂不开发）
                show_slide_bigarrow: false,
                //遮罩显隐相关
                show_enter_mask: true,
                enter_mask_state: '',
                //todo 研讨主题信息集合，当前活动主题（页）和置顶消息（精华）均从主题集合中动态计算
                channel_subjects: [],
                //todo 研讨消息信息集合
                channel_messages: [],
                //todo 在线用户列表
                channel_users: [],
                //激活的主题，todo 当收到切换页面通知时，需要设置
                active_page: {},
                active_page_index: 0,
                //置顶消息列表，todo 当首次连入时、有置顶时，需要设置
                stick_messages: [],
                //todo 网络连接对象，连接参数从channel_info中获取
                websock: "",
                //todo 连接状态，当连接状态发生改变时，给这个变量设置不同的值
                is_connected: false,//连接socket是否成功
                websock_state: "",
                //todo 显示界面切换相关
                show_tabbox: "forum",
                chat_mode: false,
                //todo 移动端适配相关
                is_mobile: false,

                // 弹幕相关参数设置
                barrageIsShow: true,
                barrageLoop: false,
                barrageList: [],
                tempBarrageList: [],
                is_showing_bullet: false,
                bullet_looper: false,

                course_id: 0,
                forbidden: false, // 是否被禁言
                is_temp_user_forbidden: false, // 聊天弹窗用户是否被禁言
                temp_user_id: -1, // 聊天弹窗用户ID
                inputting_words: '', // 输入框输出内容
                is_socket_opened: false, //socket是否开启
                all_raise_left_time: [], // 用于计时的仅保存置顶剩余秒数的列表，用于每秒刷新
                left_img: '/static/img/zuo.jpg', // 聊天框箭头左部
                right_img: '/static/img/you.jpg', // 聊天框箭头右部

                dialogVisible: false, // 置顶时间确认框打开与否控制字段
                messageDialogVisible: false, // 置顶消息删除或修改框打开与否控制字段
                subjectNameDialogVisible: false,
                newSubjectDialogVisible: false,
                temp_outer_id: '', // 暂存打开中聊天信息outer_id字段
                temp_change_message: '', // 暂存被修改的信息
                temp_change_message_old: '', // 暂存被修改信息，用以和修改后的对比

                imgDialogVisible: false,
                temp_img_width: '10%',
                temp_img_height: '10%',
                imgShow: '',

                temp_subject_name: '',
                temp_subject_name_old: '',
                temp_subject_content: '',
                temp_subject_content_old: '',
                temp_subject_id: '',

                noteDialogVisible: false,
                note_info_old: '',
                note_info: '',

                pic_list: [],
                max_pic_length: 3,
                emoji_list: ['😠','😩','😲','😞','😵','😰','😒','😍','😤','😜','😝','😋','😘','😚','😷','😳','😃','😅',
                    '😆','😁','😂','😊','☺','😄','😢','😭','😨','😣','😡','😌','😖','😔','😱','😪','😏','😓','😥','😫',
                    '😉','🙅','🙆','🙈','🙊','🙉','🙋','🙌','🙍','🙎','🙏','❤','💔','💣','💤','💦','💪','✌','👍','👋',
                    '👏','👌','👎','👐','☀','☁','☔','⛄','⚡','❄','⛅','🌛','🌹','🍉'],
                // ,'👅','🐔','🐒','🐱','🐴','🐵','🐶','🐷',
                is_emoji_show: false,

                all_forbidden_users: [],
                is_enter_clicked: false,
                is_repeat: false,
                let_relogin: false,
                retry_times_remaining: 3,
                activeNames: '',

                // cache_stick_messages: [],
                is_back_play: false,
                is_back_play_end: false,
                is_back_play_playing: true,
                cache_active_page: {},
                cache_channel_messages: [],
                cache_channel_subjects: [],
                whole_channel_messages: [],
                whole_channel_subjects: [],

                //todo 测试用数据和残留代码，有用的移动到上方，剩余将被清理
                lecture_page_title: '绩效计划如何制定？',
                lecture_page_subtitle: '方法一、PDCA计划循环法（副标题）',
                path: '',
                sock_keep: '',

                all_words: [],
                user_id: cookies.get('userId'),
                user_info: {},
                symposium_subject: [],
                all_up_message: [],//置顶信息列表
                all_user: [],

                subjectContentDialogVisible: false,
                usersDialogVisible: false,
                deleteDialogVisible: false,
                // is_teacher: false,
                course_name: '',


                all_raise: [],
                all_kanban: [],
                temp_long_word: '',
                temp_pack_count: 0,
                temp_pack: 0,
                long_word: false,
                temp_change_message_id: '',

                show_types: [{'key': 0, 'value': '微信模式'}, {'key': 1, 'value': '看板模式'}],
                show_type: '微信模式',
                screen_height: {height: window.screen.height - 250 + 'px'},
                screen_height_mobile: {height: window.screen.height - 200 + 'px'},
                center_button_flow_left: {left: document.body.clientWidth * 0.6 - 230 + 'px'},
                center_button_flow_left_mobile: {left: document.body.clientWidth - 180 + 'px'},
                doc_width: document.body.clientWidth,
                delete_message_info: '',
                delete_message_message: '',
                timer1: null,
            }
        },
        // 执行在模板渲染前，涉及到页面布局和结构调整的操作、数据等
        created: function () {
            document.querySelector('html').setAttribute('style', '-webkit-text-size-adjust: none;')
        },
        // 执行在Html生成之后，涉及到DOM操作等局部内容更新
        mounted: function () {
            // 加载课节信息
            let args = {'lessonId': this.$route.params.id};
            this.load_channel_info(args)
            if (this._isMobile()) {
                this.is_mobile = true
            }
        },
        beforeDestroy() {
            // 销毁监听
        },
        computed: {
            ...mapState({
                // 绑定用户登录状态，当登录状态发生变化时自动执行断开连接或准备连接操作（弹窗）
                sign_on: state => state.loginState.sign_on,
                login_user: state => state.loginState.user_info,
                // 研讨课程基本信息（感觉获取时间比较长）
                channel_info: state => state.channel.channel_info,
                is_symposium_opened: state => state.channel.is_symposium_opened,
                is_teacher: state => state.channel.is_teacher,
                is_course_end: state => state.channel.is_end,
                is_bad_connect: state => state.channel.is_bad_connect,
                is_init: state=>state.channel.is_init,
                is_buy: state=>state.channel.is_buy,
            }),
            //主题背景色（标题栏和操作栏）
            bg_color: function () {
                if (!this.channel_info || !this.channel_info.course_info) {
                    return ''
                }
                return 'background: ' + this.channel_info.course_info.header_bg_color + ';'
            },
        },
        watch: {
            sign_on: function () {
                if (this.sign_on) {
                    // 显示遮罩，准备连接
                } else {
                    // 断开websocket连接
                }
            },
            is_symposium_opened: function () {
                if (this.is_symposium_opened) {
                    // this.is_init = false;
                    this.change_init_state(false)
                }
            }
        },
        methods: {
            ...mapActions({
                load_channel_info: 'channel/load_channel_info',
                change_warning_message: 'warningBar/change_message',
                change_symposium_state: 'channel/change_symposium_state',
                change_real_symposium_state: 'channel/change_real_symposium_state',
                change_init_state: 'channel/change_init_state',
                change_show_state: 'loginState/change_show_state',
                change_user_info: 'loginState/change_user_info',
                get_and_change_all_login: 'loginState/get_and_change_all_login',
                set_is_bad_connect: 'channel/set_is_bad_connect',
                note_change: 'channel/note_change',
                set_is_course_end: 'channel/set_is_course_end',
            }),
            // 插入弹幕
            addBullet2barrageList: function () {
                this.is_showing_bullet = true
                let that = this
                let interval = 1000
                let looper = setInterval(function () {
                    if (that.tempBarrageList.length > 0){
                        let message = that.tempBarrageList.shift()
                        that.barrageList.push(message)
                    }else{
                        clearInterval(looper);
                        that.is_showing_bullet = false
                        that.bullet_looper = false
                    }
                }, interval)
                this.bullet_looper = looper
            },
            addBullet2tempBarrageList: function (msg) {
                this.tempBarrageList.push({
                    id: msg.outer_id,
                    avatar: msg.user_info.avatar_url,
                    msg: msg.message,
                    time: msg.message.length < 10 ? 5 : 8,
                    type: MESSAGE_TYPE.NORMAL,
                    extraWidth: 0,
                });
            },
            // 从页面点击进入研讨，关闭遮罩，打开websocket连接
            enter_symposium: function (is_teacher_enter = false) {
                this.enter_mask_state = '.'
                this.is_enter_clicked = true
                if (is_teacher_enter){
                    this.change_symposium_state(true)
                }
                //执行连接动作，连接建立后自动关闭登入遮罩
                this.do_connect_channel();
            },
            enter_symposium_back_play: function(){
                this.enter_mask_state = '.'
                this.is_back_play = true
                this.is_enter_clicked = true
                this.do_connect_channel();
            },
            // 开启websocket连接
            do_connect_channel: function () {
                let that = this
                let path = ''
                let device_name = this.get_device()
                if (that.channel_info.is_ssl) {
                    path = "wss://" + that.channel_info.path + '/' + that.channel_info.user_info['session_id'] + '/' + device_name
                } else {
                    path = "ws://" + that.channel_info.path + '/' + that.channel_info.user_info['session_id'] + '/' + device_name
                }
                // path = "wss://hr.ujoyer.com/b#/cl/58"
                console.log(path)

                that.websock = new WebSocket(path)
                that.websock.onmessage = that.websocket_on_message;
                that.websock.onopen = that.websocket_on_open;
                that.websock.onerror = that.websocket_on_error;
                that.websock.onclose = that.websocket_on_close;
                this.enter_mask_state = '..';
            },
            websocket_on_open: function () {
                this.is_connected = true;
                this.enter_mask_state = '...';
                this.show_enter_mask = false;
                this.websocketnewuser();
            },
            websocket_on_message: function (e) {
                let res = JSON.parse(e.data)
                // console.log(res)
                if (res['type'] === 'new_user') {
                    this.channel_users = res['data']
                    // console.log('new_user', res['data'])
                } else if (res['type'] === 'raise' && (!this.is_course_end || this.is_teacher)) {
                    // console.log('raise')
                    // this.set_raise_info(res['message'])
                    if (res['page_msgs'] !== 'not_set') {
                        this.set_up_message_to_subject_and_set_info(res['page_msgs'])
                    }
                } else if (res['type'] === 'format') {
                    // console.log('format')
                    this.enter_mask_state = '';
                    this.retry_times_remaining = 3
                    // this.show_enter_mask = false;
                    let lesson_id = this.$route.params.id
                    // console.log('get format info', res)
                    if (this.is_back_play && !this.is_teacher){
                        this.set_play_back_subjects(res['subjects'])
                        this.set_current_page_and_info_back_play(res['subjects'])
                        this.set_all_words_back_play(res['all_messages'], lesson_id)
                        this.play_back_begin()
                    }else{
                        this.channel_subjects = res['subjects']
                        this.all_forbidden_users = res['all_forbidden_users']
                        this.set_current_page_and_info(res['subjects'])
                        // this.set_raise_info(res['message'])
                        this.set_all_words(res['all_messages'], lesson_id)
                    }
                    setTimeout(()=>{
                        let stick_div = document.getElementById('stick-scroll-div');
                        if (stick_div){
                            stick_div.scrollTop = stick_div.scrollHeight;
                        }
                        let forum_div = document.getElementById('forum-scroll-div');
                        if (forum_div){
                            forum_div.scrollTop = forum_div.scrollHeight
                        }
                    }, 1000)
                } else if (res['type'] === 'symposium_opened' && !this.is_course_end) {
                    // console.log('symposium_opened')
                    this.note_message('已开始上课')
                    this.change_symposium_state(true)
                    this.change_real_symposium_state(true)
                } else if (res['type'] === 'symposium_closed' && !this.is_course_end) {
                    // console.log('symposium_closed')
                    this.note_message('已结束课程')
                    if(!this.is_teacher){
                        this.change_symposium_state(false)
                        this.websock.send(JSON.stringify({'quit': true}));
                        this.retry_times_remaining = 0
                    }
                    this.change_real_symposium_state(false)
                } else if (res['type'] === 'set_forbidden' && !this.is_course_end) {
                    // console.log('set_forbidden')
                    this.forbidden = res['forbidden']
                } else if (res['type'] === 'set_forbidden_users' && !this.is_course_end) {
                    // console.log('set_forbidden_users')
                    this.all_forbidden_users = res['data']
                } else if (res['type'] === 'subject_name_change' && (!this.is_course_end || this.is_teacher)) {
                    // console.log('subject_name_change')
                    let subject_id = res['subject_id']
                    let name = res['name']
                    this.subject_name_changed(subject_id, name)
                } else if (res['type'] === 'subject_content_change' && (!this.is_course_end || this.is_teacher)) {
                    // console.log('subject_content_change')
                    let subject_id = res['subject_id']
                    let content = res['content']
                    this.subject_content_changed(subject_id, content)
                } else if (res['type'] === 'support_up_message' && !this.is_course_end) {
                    // console.log('support_up_message')
                    let m_id = res['message_id']
                    let is_support = res['is_support']
                    let is_reset = res['is_reset']
                    this.set_support_or_stamp(m_id, is_support, is_reset)
                } else if (res['type'] === 'message_change' && (!this.is_course_end || this.is_teacher)) {
                    let m_id = res['message_id']
                    let message = res['message']
                    let is_move = res['is_move']
                    // console.log('message_change', message, m_id, is_move)
                    this.change_message_info(m_id, message, is_move)
                } else if (res['type'] === 'support_fail' && !this.is_course_end) {
                    // console.log('support_fail')
                    this.change_warning_message('已经为该内容点过赞或点过踩')
                } else if (res['type'] === 'change_page' && (!this.is_course_end || this.is_teacher)) {
                    // console.log('get change_page', res['page'])
                    this.set_current_page_and_info_by_page(res['page'])
                } else if (res['type'] === 'add_page' && (!this.is_course_end || this.is_teacher)) {
                    // console.log('add_page', res['subjects'], res['subject'])
                    this.add_subject(res['subject'])
                } else if (res['type'] === 'delete_up_message' && (!this.is_course_end || this.is_teacher)) {
                    // console.log('delete_up_message', res['message_id'])
                    this.delete_up_message_and_set_info(res['message_id'])
                } else if (res['type'] === 'delete_chat_message' && (!this.is_course_end || this.is_teacher)) {
                    // console.log('delete_chat_message', res['message_outer_id'])
                    this.delete_chat_message_by_outer_id(res['message_outer_id'])
                } else if (res['type'] === 'delete_raise_message' && (!this.is_course_end || this.is_teacher)) {
                    // console.log('delete_raise_message', res['messages'])
                    // this.set_raise_info(res['messages'])
                } else if (res['type'] === 'delete_subject' && (!this.is_course_end || this.is_teacher)) {
                    // console.log('delete_subject', res['subject_id'])
                    let subject_id = res['subject_id']
                    let page_id = res['next_page']
                    this.delete_and_set_subject(subject_id, page_id)
                    // this.set_raise_info(res['messages'])
                } else if (res['type'] === 'repeat'){
                    // console.log('repeat')
                    this.is_repeat = true
                    this.show_enter_mask = true
                } else if (res['type'] === 'repeat_checked'){
                    // console.log('repeat_checked')
                    this.is_repeat = false
                    this.show_enter_mask = false
                } else if (res['type'] === 'note_change'){
                    // console.log('note_change')
                    this.note_change(res['note'])
                } else if (res['type'] === 'message') {
                    console.log('message in', res)
                    //普通用户消息，显示到研讨窗口和精选窗口
                    if (!this.is_course_end || this.is_teacher){
                        this.channel_messages.push(res)
                        this.show_message_in_bullet_list(res)
                        this.scroll_to_bottom();
                        // console.log('print channel_messages:', this.channel_messages)
                    }
                }
            },
            scroll_to_bottom: function () {
                setTimeout(function () {
                    let forum_div = document.getElementById('forum-scroll-div');
                    if (forum_div && (forum_div.scrollTop == 0 || forum_div.scrollHeight - forum_div.scrollTop < 1.7*parseFloat(window.getComputedStyle(forum_div).height)))
                        forum_div.scrollTop = forum_div.scrollHeight;
                    let stick_div = document.getElementById('stick-scroll-div');
                    if (stick_div && (stick_div.scrollTop == 0 || stick_div.scrollHeight - stick_div.scrollTop < 1.7*parseFloat(window.getComputedStyle(stick_div).height)))
                        stick_div.scrollTop = stick_div.scrollHeight;
                }, 300)
            },
            scroll_to_bottom_anyway: function(){
                let stick_div = document.getElementById('stick-scroll-div');
                if (stick_div){
                    stick_div.scrollTop = stick_div.scrollHeight;
                }
                let forum_div = document.getElementById('forum-scroll-div');
                if (forum_div){
                    forum_div.scrollTop = forum_div.scrollHeight
                }
            },
            stick_scroll_to_bottom_anyway: function(){
                let stick_div = document.getElementById('stick-scroll-div');
                if (stick_div){
                    stick_div.scrollTop = stick_div.scrollHeight;
                }
            },
            forum_scroll_to_bottom_anyway: function(){
                let forum_div = document.getElementById('forum-scroll-div');
                if (forum_div){
                    forum_div.scrollTop = forum_div.scrollHeight
                }
            },
            set_play_back_subjects(subject){
                this.cache_channel_subjects = JSON.parse(JSON.stringify(subject))
                this.whole_channel_subjects = JSON.parse(JSON.stringify(subject))
                for (let i = 0; i < subject.length; i++){
                    subject[i].pages[0].m_ids = []
                }
                this.channel_subjects = subject
            },
            check_device(){
                var UA = window.navigator.userAgent,
                    IsAndroid = (/Android|HTC/i.test(UA) || !! (window.navigator['platform'] + '').match(/Linux/i)),
                    IsIPad = !IsAndroid && /iPad/i.test(UA),
                    IsIPhone = !IsAndroid && /iPod|iPhone/i.test(UA),
                    IsIOS = IsIPad || IsIPhone;
                if(IsIOS){
                    return 'ios'
                }else if(IsAndroid){
                    return 'android'
                }else{
                    return 'windows'
                }
            },
            check_browner(){
               // Useragent RegExp
                var ua = window.navigator.userAgent;
                var rwebkit = /(webkit)[ \/]([\w.]+)/;
                var ropera = /(opera)(?:.*version)?[ \/]([\w.]+)/;
                var rmsie = /(msie) ([\w.]+)/;
                var rmozilla = /(mozilla)(?:.*? rv:([\w.]+))?/;

                var match = rwebkit.exec( ua ) ||
                    ropera.exec( ua ) ||
                    rmsie.exec( ua ) ||
                    ua.indexOf("compatible") < 0 && rmozilla.exec( ua ) ||
                    [];

                let temp = { browser: match[1] || "", version: match[2] || "0" };
                return temp
            },
            get_device(){
                var ua = navigator.userAgent.toLowerCase();
                var regex1 = /\((.+?)\)/g;
                var res = ua.match(regex1)[0];
                return res.substring(1, res.length - 1);
            },
            emoji_icon_enter: function(){
                this.is_emoji_show = !this.is_emoji_show
                setTimeout(this.scroll_to_bottom_anyway, 500)
            },
            click_input: function(){
                document.getElementById('upload_input').click()
            },
            delete_pic: function(index){
                this.pic_list.splice(index,1)
            },
            stripscript: function (s) {
                return s.replace(/<script.*?>.*?<\/script>/ig, '');
            },
            still_login: function(){
                console.log('still_login')
                this.websock.send(JSON.stringify({'still_login': true}));
            },
            focus_input: function(){
                let forum_div = document.getElementById('forum-scroll-div');
                forum_div.scrollTop = forum_div.scrollHeight;
            },
            websocket_on_error: function (e) {
                console.log('连接出错', e);
                // if (this.retry_times_remaining > 0) {
                //     setTimeout(this.retry_login, 3000)
                // } else {
                //     this.is_connected = false
                //     this.show_enter_mask = true
                //     this.is_enter_clicked = false
                //     this.set_is_bad_connect(true)
                // }
            },
            websocket_on_close: function (e) {
                console.log('断开连接', e);
                if (e.reason === 'repeat'){
                    console.log('repeat reason logout')
                    this.$message({
                        message: '账号已在其他设备登录，请重新登录',
                        type: 'warning'
                    });
                    this.let_relogin = true
                    this.change_show_state('on')
                }else if (e.reason === 'wrong_session'){
                    console.log('wrong session logout')
                    this.$message({
                        message: '登录状态错误，请重新登录',
                        type: 'warning'
                    });
                    this.let_relogin = true
                    this.change_show_state('on')
                }else if (e.reason === ''){
                    console.log('no reason logout')
                    if (this.retry_times_remaining > 0) {
                        setTimeout(this.retry_login, 3000)
                    } else {
                        this.is_connected = false
                        this.show_enter_mask = true
                        this.is_enter_clicked = false
                        this.set_is_bad_connect(true)
                    }
                    // this.is_connected = false
                    // this.is_enter_clicked = false
                    return
                }else if(e.reason === 'justClose'){
                    return
                }
                // else if (e.reason === 'logout'){
                //     if (this.retry_times_remaining > 0){
                //         setTimeout(this.retry_login, 3000)
                //         return
                //     }else{
                //         this.is_connected = false
                //         this.show_enter_mask = true
                //         this.is_enter_clicked = false
                //     }
                // }
                //todo 此处断连后应不可重复登录，目前还时可以继续点击进入研讨
                this.is_connected = false
                this.show_enter_mask = true
                this.is_enter_clicked = false
            },
            // img_click(event, message){
                // console.log(event)
                // if (event.target.localName === 'img'){
                //     this.imgDialogVisible = true
                //     this.imgShow = '<img src="' + event.target.currentSrc + '">'
                //     this.temp_img_width = String(event.target.naturalWidth / document.body.clientWidth * 100 + 12) + '%'
                //     // console.log(this.temp_img_width, event.target.naturalWidth, document.body.clientWidth)
                // }
            // },
            websocketsend() {//数据发送
                if (!this.is_course_end || this.is_teacher){
                    console.log('saying')
                    if (this.pic_list.length > 0  && !this.forbidden){
                        for (let i = 0; i < this.pic_list.length; i++){
                            this.websock.send(JSON.stringify({'message': '<img style="max-width: 180px" src="' + this.pic_list[i] + '">'}));
                        }
                        this.pic_list = []
                    }
                    if (this.inputting_words !== '' && !this.forbidden) {
                        // this.inputting_words = this.stripscript(this.inputting_words)
                        this.websock.send(JSON.stringify({'message': this.inputting_words.trim()}));
                        this.inputting_words = ''
                    }
                    this.is_emoji_show = false
                    document.getElementById('input_area').focus()
                }
            },
            calc_pause_time(msg){
                let temp = msg.message.length / 10
                if (temp>10){
                    temp = 10
                }else if (temp < 3){
                    temp = 3
                }
                return temp
            },
            play_back_begin(){
                this.loop_id =  setInterval(this.play_back_one_step, 1000)
            },
            play_back_one_step(){
                if (this.cache_channel_messages.length > 0){
                    let temp_msg = this.cache_channel_messages.shift()
                    let pause_time = this.calc_pause_time(temp_msg)
                    if (temp_msg.is_important){
                        this.set_play_back_raise(temp_msg)
                    }
                    this.channel_messages.push(temp_msg)
                    this.show_message_in_bullet_list(temp_msg)
                    clearInterval(this.loop_id)
                    this.loop_id = setInterval(this.play_back_one_step, pause_time * 1000)
                    setTimeout(this.forum_scroll_to_bottom_anyway, 500)
                }else{
                    clearInterval(this.loop_id)
                    this.is_back_play_end = true
                    this.is_back_play_playing = false
                }
            },
            back_play_stop(){
                clearInterval(this.loop_id)
                this.is_back_play_playing = false
            },
            back_play_play(){
                this.play_back_one_step()
                this.is_back_play_playing = true
            },
            back_play_faster(){
                clearInterval(this.loop_id)
                this.play_back_one_step()
                // this.play_back_begin()
                this.is_back_play_playing = true
            },
            back_play_end(){
                clearInterval(this.loop_id)
                this.channel_messages = this.whole_channel_messages
                this.channel_subjects = this.whole_channel_subjects
                this.is_back_play_end = true
                this.is_back_play_playing = false
                this.set_current_page_and_info_by_page(this.active_page.outer_id)
                setTimeout(this.scroll_to_bottom_anyway, 1000)
            },
            show_message_in_bullet_list(res){
                this.addBullet2tempBarrageList(res);
                if (!this.is_showing_bullet && this.show_tabbox === 'stick'){
                    this.addBullet2barrageList()
                }
            },
            set_play_back_raise(msg){
                let message = {
                    'id': msg['id'],
                    'user': {
                        'id': msg.hasOwnProperty('user_info')? msg['user_info']['user_id']: msg['user']['id'],
                        'name':  msg.hasOwnProperty('user_info')? msg['user_info']['name']: msg['user']['name'],
                        'avatar_url':  msg.hasOwnProperty('user_info')? msg['user_info']['avatar_url']:msg['user']['avatar_url'],
                    },
                    'symposium_id': this.cache_channel_subjects[0]['symposium_id'],
                    'page_id': msg['page_id'],
                    'up_time': msg['now_time'],
                    'message': msg['message'],
                    'is_important': msg['is_important'],
                    'is_left': msg['is_left'],
                    'support_count': 0,
                    'stamp_count': 0,
                    'outer_id': msg['outer_id'],
                }
                if (this.active_page['outer_id'] !== msg['page_id']){
                    this.set_current_page_and_info_by_page(msg['page_id'])
                }
                this.set_up_message_to_subject_and_set_info(message)
                setTimeout(this.stick_scroll_to_bottom_anyway, 200)
            },
            websocketnewuser() {//新用户发送user_id
                // console.log(this.channel_info.user_info)
                this.websock.send(JSON.stringify({'new': {'data': this.channel_info.user_info,'is_back_play': this.is_back_play}}));
            },
            retry_login(){
                let that = this
                let args = {'lessonId': this.$route.params.id};
                console.log('retry_login times remaining:', this.retry_times_remaining)
                this.load_channel_info(args).then(function () {
                    that.do_connect_channel()
                })
                this.retry_times_remaining -= 1
            },
            change_symposium_opened(type) {
                let lesson_id = this.$route.params.id
                let args = {
                    'lesson_id': lesson_id,
                    'type': type,
                }
                if (type === 'start') {
                    this.change_symposium_state(true)
                    // this.websock.send(JSON.stringify({'start_or_end_symposium': args}))
                }
            },
            start_or_end_symposium(type){
                let lesson_id = this.$route.params.id
                let args = {
                    'lesson_id':lesson_id,
                    'type':type,
                }
                if (type === 'start'){
                    this.websock.send(JSON.stringify({'start_or_end_symposium': args}))
                }else if (type === 'end'){
                    this.$confirm('是否现在下课?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(()=>{
                        this.websock.send(JSON.stringify({'start_or_end_symposium': args}))
                        // console.log(type)
                    }).catch(()=>{
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    })
                }
            },
            uploadAction:async function(event){
                if (this.pic_list.length >= this.max_pic_length){
                    this.$message({
                        message: '最多一次上传' + String(this.max_pic_length) + '张图片，请发送后再上传',
                        type: 'warning'
                    });
                    return
                }
                this.compressAndUpdate(event.target.files[0])
                // this.img_with(imgUrl)
            },
            async uploadImg(blob, name) {
                let formData = new FormData();
                formData.append('file', blob, name)
                formData.append('filename', name)
                formData.append('user_id', this.channel_info.user_info.id);
                let response = await Upload.upload_file_to_odoo(formData);
                let imgUrl = response.data.imgUrl
                if (process.env.NODE_ENV !== 'production'){
                    let list = imgUrl.split('api')
                    imgUrl = "http://localhost:8000/api" + list[1]
                }
                this.pic_list.push(imgUrl)
            },
            compressAndUpdate(blob) {
                const name = blob.name
                const type = blob.type
                const self = this
                const reader = new FileReader()
                reader.readAsDataURL(blob)
                reader.onload = function (event) {
                    console.log(event)
                    const base64 = event.target.result
                    const scale = 1
                    self.compressImg(base64, scale, self.uploadImg, name, type)
                }
            },
            compressImg(base64, scale, callback, m_name ,m_type) {
                console.log(`执行缩放程序，scale=${scale}，大小=${base64.length}`)
                const maxWidth = 1080;
                const img = new Image()
                img.src = base64
                img.onload = function () {
                    console.log(`图片长宽为，长=${this.height}，宽=${this.width}`)
                    let theWidth = 0
                    let theHeight = 0
                    if (this.width <= maxWidth){
                        theWidth = this.width
                        theHeight = this.height
                    }else{
                        theWidth = maxWidth
                        theHeight = this.height * maxWidth / this.width
                    }
                    console.log(`处理后图片长宽为，长=${theHeight}，宽=${theWidth}`)
                    const canvas = document.createElement('canvas')
                    const ctx = canvas.getContext('2d')
                    canvas.setAttribute('width', theWidth)
                    canvas.setAttribute('height', theHeight)
                    ctx.clearRect(0, 0, canvas.width, canvas.height)
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
                    let base64 = canvas.toDataURL(m_type)
                    // 目标是小于1兆
                    while (base64.length > 1024 * 1024 * 1) {
                        scale -= 0.05
                        base64 = canvas.toDataURL(m_type, scale)
                    }
                    console.log(`最终缩放率，scale=${scale}，大小=${base64.length}`)
                    const arr = base64.split(',')
                    const mime = arr[0].match(/:(.*?);/)[1]
                    const bytes = atob(arr[1])
                    const bytesLength = bytes.length
                    const u8arr = new Uint8Array(bytesLength)
                    for (let i = 0; i < bytes.length; i++) {
                        u8arr[i] = bytes.charCodeAt(i)
                    }
                    const blob = new Blob([u8arr], {type: mime})
                    callback(blob, m_name)
                }
            },
            add_emoji_to_input(icon){
                this.inputting_words += icon
            },
            reload(){
                location.reload()
            },
            note_message(info){
                this.$message({
                    type: 'info',
                    message: info
                });
            },
            set_all_words(all_messages, lesson_id) {
                // this.all_words = all_messages
                let list = []
                all_messages.forEach((item) => {
                    list.push({
                        lesson_id: lesson_id,
                        message: item.message,
                        outer_id: item.outer_id,
                        time: item.up_time,
                        type: 'message',
                        is_important: item.is_important,
                        user_info: {
                            avatar_url: item['user'] ? item['user']['avatar_url'] : item['user_info'] ? item['user_info']['avatar_url'] : '',
                            forbidden: false,
                            name: item['user'] ? item['user']['name'] : item['user_info'] ? item['user_info']['name'] : '',
                            user_id: item['user'] ? item['user']['id'] : item['user_info'] ? item['user_info']['user_id'] : '',
                        }
                    })
                })
                this.channel_messages = list
            },
            set_all_words_back_play(all_messages, lesson_id) {
                let list = []
                all_messages.forEach((item) => {
                    let temp = this.check_if_message_raised(item.outer_id, this.cache_channel_subjects)
                    list.push({
                        lesson_id: lesson_id,
                        message: item.message,
                        outer_id: item.outer_id,
                        time: item.up_time,
                        page_id: temp[1],
                        is_left: temp[2],
                        type: 'message',
                        is_important: temp[0],
                        user_info: {
                            avatar_url: item['user'] ? item['user']['avatar_url'] : item['user_info'] ? item['user_info']['avatar_url'] : '',
                            forbidden: false,
                            name: item['user'] ? item['user']['name'] : item['user_info'] ? item['user_info']['name'] : '',
                            user_id: item['user'] ? item['user']['id'] : item['user_info'] ? item['user_info']['user_id'] : '',
                        }
                    })
                })
                this.whole_channel_messages = JSON.parse(JSON.stringify(list))
                this.cache_channel_messages = list
            },
            check_if_message_raised(outer_id, subject){
                let res = [false, false, false]
                if (subject) {
                    for (let i = 0; i < subject.length; i++) {
                        for (let x = 0; x < subject[i]['pages'][0].m_ids.length; x++) {
                            if(subject[i]['pages'][0].m_ids[x]['outer_id'] === outer_id){
                                res = [true, subject[i]['pages'][0]['outer_id'], subject[i]['pages'][0].m_ids[x]['is_left']]
                                return res
                            }
                        }
                    }
                }
                return res
            },
            set_current_page_and_info(subjects) {
                if (subjects) {
                    for (let i = 0; i < subjects.length; i++) {
                        for (let x = 0; x < subjects[i]['pages'].length; x++) {
                            if (subjects[i]['pages'][x]['is_current']) {
                                this.active_page = subjects[i]['pages'][x]
                                this.set_all_up_message(subjects[i]['pages'][x]['m_ids'])
                                this.active_page_index = i + 1
                            }
                        }
                    }
                }
            },
            set_current_page_and_info_back_play(subjects) {
                if (subjects) {
                    for (let i = 0; i < subjects.length; i++) {
                        for (let x = 0; x < subjects[i]['pages'].length; x++) {
                            if (subjects[i]['pages'][x]['is_current']) {
                                this.active_page = subjects[i]['pages'][x]
                                this.set_all_up_message(subjects[i]['pages'][x]['m_ids'])
                                this.active_page_index = i + 1
                            }
                        }
                    }
                }
            },
            set_all_up_message(res) {
                for (let i = 0; i < res.length; i++) {
                    let msg = res[i]['message']
                    res[i]['message'] = res[i]['message'].trim()
                    // msg.replace(/(\r\n|\r|\n){2,}/g, '$1\n')
                    if (msg.length >= 101) {
                        res[i]['title'] = msg.slice(0, 100) + '...'
                    } else {
                        res[i]['title'] = msg
                    }
                }
                // this.all_up_message = res
                // 刷新置顶区滚动条到最底部
                // setTimeout(function () {
                //   let div = document.getElementById('root_center');
                //   div.scrollTop = div.scrollHeight;
                // }, 200)
            },
            show_user(user_info) {
                // window.open("http://localhost:8080/user/" + user_info.id)
                window.open("https://hr.ujoyer.com/user/" + user_info.id)
            },
            click_quit() {
                if (window.__wxjs_environment === 'miniprogram') {
                    wx.miniProgram.navigateTo({url: '/pages/course/index?id=' + this.channel_info.course_info.id})
                } else {
                    // window.open("http://localhost:8080/courses/" + this.channel_info.course_info.id)
                    window.open("https://hr.ujoyer.com/courses/" + this.channel_info.course_info.id)
                }
            },
            set_raise_info(res) {
                if (res) {
                    for (let i = 0; i < res.length; i++) {
                        if (res[i]['message'].length >= 21) {
                            let msg = res[i]['message']
                            res[i]['title'] = msg.slice(0, 20) + '...'
                        } else {
                            res[i]['title'] = res[i]['message']
                        }
                    }
                    res = this.calc_date_for_raise(res)
                }
                // console.log('raise', res)
                this.stick_messages = res
            },
            set_up_message_to_subject_and_set_info(message) {
                if (this.channel_subjects) {
                    let obj = this.channel_subjects
                    for (let i = 0; i < obj.length; i++) {
                        for (let x = 0; x < obj[i]['pages'].length; x++) {
                            if (obj[i]['pages'][x]['is_current']) {
                                let is_set = true
                                for (let z = 0; z < obj[i]['pages'][x]['m_ids'].length; z++) {
                                    if (obj[i]['pages'][x]['m_ids'][z]['outer_id'] == message['outer_id']) {
                                        is_set = false
                                    }
                                }
                                if (is_set) {
                                    obj[i]['pages'][x]['m_ids'].push(message)
                                    this.set_all_up_message(obj[i]['pages'][x]['m_ids'])
                                }
                            }
                        }
                    }
                }
            },
            subject_name_changed(subject_id, name) {
                if (this.channel_subjects) {
                    let obj = Object.create(this.channel_subjects)
                    for (let i = 0; i < obj.length; i++) {
                        if (obj[i]['outer_id'] === subject_id) {
                            // console.log('subject:', obj[i]['name'], '已改名为：', name)
                            obj[i]['name'] = name
                            for (let z = 0; z < obj[i]['pages'].length; z++) {
                                obj[i]['pages'][z]['subject_name'] = name
                            }
                        }
                    }
                    this.channel_subjects = obj
                }
                if (this.active_page) {
                    let page = Object.create(this.active_page)
                    page['subject_name'] = name
                    this.active_page = page
                }
            },
            subject_content_changed(subject_id, content) {
                if (this.channel_subjects) {
                    let obj = Object.create(this.channel_subjects)
                    for (let i = 0; i < obj.length; i++) {
                        if (obj[i]['id'] === subject_id) {
                            // console.log('subject:', obj[i]['content'], '已改内容为：', content)
                            obj[i]['content'] = content
                            for (let z = 0; z < obj[i]['pages'].length; z++) {
                                obj[i]['pages'][z]['content'] = content
                            }
                        }
                    }
                    this.channel_subjects = obj
                }
                if (this.active_page) {
                    let page = Object.create(this.active_page)
                    page['content'] = content
                    this.active_page = page
                }
            },
            set_support_or_stamp(message_id, is_support, is_reset) {
                if (this.channel_subjects) {
                    for (let i = 0; i < this.channel_subjects.length; i++) {
                        for (let x = 0; x < this.channel_subjects[i]['pages'].length; x++) {
                            for (let z = 0; z < this.channel_subjects[i]['pages'][x]['m_ids'].length; z++) {
                                if (this.channel_subjects[i]['pages'][x]['m_ids'][z]['outer_id'] === message_id) {
                                    if (is_support) {
                                        if (is_reset) {
                                            this.channel_subjects[i]['pages'][x]['m_ids'][z]['support_count'] += 1
                                            this.channel_subjects[i]['pages'][x]['m_ids'][z]['stamp_count'] -= 1
                                        } else {
                                            this.channel_subjects[i]['pages'][x]['m_ids'][z]['support_count'] += 1
                                        }
                                    } else {
                                        if (is_reset) {
                                            this.channel_subjects[i]['pages'][x]['m_ids'][z]['stamp_count'] += 1
                                            this.channel_subjects[i]['pages'][x]['m_ids'][z]['support_count'] -= 1
                                        } else {
                                            this.channel_subjects[i]['pages'][x]['m_ids'][z]['stamp_count'] += 1
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            change_message_info(message_id, message, is_move) {
                for (let i = 0; i < this.active_page['m_ids'].length; i++) {
                    if (this.active_page['m_ids'][i]['outer_id'] === message_id) {
                        let obj = Object.create(this.active_page)
                        obj['m_ids'][i]['message'] = message
                        // message.replace(/(\r\n|\r|\n){2,}/g, '\n')
                        if (is_move) {
                            // console.log(obj['m_ids'][i]['is_left'])
                            obj['m_ids'][i]['is_left'] = !obj['m_ids'][i]['is_left']
                            // console.log(obj['m_ids'][i]['is_left'])
                        }
                        this.active_page = obj
                        break
                    }
                }
                if (this.channel_subjects) {
                    for (let i = 0; i < this.channel_subjects.length; i++) {
                        for (let x = 0; x < this.channel_subjects[i]['pages'].length; x++) {
                            for (let z = 0; z < this.channel_subjects[i]['pages'][x]['m_ids'].length; z++) {
                                if (this.channel_subjects[i]['pages'][x]['m_ids'][z]['outer_id'] === message_id) {
                                    this.channel_subjects[i]['pages'][x]['m_ids'][z]['message'] = message
                                }
                            }
                        }
                    }
                }
            },
            set_current_page_and_info_by_page(page_id) {
                // console.log(this.channel_subjects, page_id)
                if (this.channel_subjects) {
                    for (let i = 0; i < this.channel_subjects.length; i++) {
                        for (let x = 0; x < this.channel_subjects[i]['pages'].length; x++) {
                            if (this.channel_subjects[i]['pages'][x]['outer_id'] === page_id) {
                                // console.log(this.channel_subjects[i]['pages'][x], page_id)
                                this.channel_subjects[i]['pages'][x]['is_current'] = true
                                this.active_page = this.channel_subjects[i]['pages'][x]
                                this.active_page_index = i + 1
                                this.set_all_up_message(this.channel_subjects[i]['pages'][x]['m_ids'])
                            } else {
                                this.channel_subjects[i]['pages'][x]['is_current'] = false
                            }
                        }
                    }
                }
            },
            delete_and_set_subject(subject_id, page_id) {
                // console.log('delete back', subject_id)
                let temp = -1
                for (let i = 0; i < this.channel_subjects.length; i++) {
                    if (subject_id === this.channel_subjects[i]['outer_id']) {
                        temp = i
                        break
                    }
                }
                if (temp !== -1) {
                    this.channel_subjects.splice(temp, 1)
                    // this.active_page_index = 1
                }
                this.set_current_page_and_info_by_page(page_id)
            },
            delete_chat_message_by_outer_id(outer_id) {
                let temp = -1
                for (let i = 0; i < this.channel_messages.length; i++) {
                    if (outer_id === this.channel_messages[i]['outer_id']) {
                        temp = i
                        break
                    }
                }
                if (temp !== -1) {
                    this.channel_messages.splice(temp, 1)
                    this.delete_up_message_and_set_info(outer_id)
                }
                this.scroll_to_bottom();
            },
            add_subject(subject) {
                if (this.channel_subjects) {
                    for (let i = 0; i < this.channel_subjects.length; i++) {
                        for (let x = 0; x < this.channel_subjects[i]['pages'].length; x++) {
                            if (this.channel_subjects[i]['pages'][x]['is_current']) {
                                this.channel_subjects[i]['pages'][x]['is_current'] = false
                            }
                        }
                    }
                    this.channel_subjects.push(subject)
                    this.active_page = subject['pages'][0]
                    this.active_page_index = this.channel_subjects.length
                    this.set_all_up_message(subject['pages'][0]['m_ids'])
                }
            },
            delete_up_message_and_set_info(message_id) {
                if (this.channel_subjects) {
                    let obj = this.channel_subjects
                    for (let i = 0; i < obj.length; i++) {
                        for (let x = 0; x < obj[i]['pages'].length; x++) {
                            let temp = -1
                            for (let z = 0; z < obj[i]['pages'][x]['m_ids'].length; z++) {
                                if (obj[i]['pages'][x]['m_ids'][z]['outer_id'] === message_id) {
                                    temp = z
                                }
                            }
                            if (temp !== -1) {
                                obj[i]['pages'][x]['m_ids'].splice(temp, 1)
                                this.active_page = obj[i]['pages'][x]
                                this.set_all_up_message(obj[i]['pages'][x]['m_ids'])
                            }
                        }
                    }
                }
            },
            calc_date_for_raise(messages) {
                let new_list = []
                let all_raise_left_time = []
                for (let i = 0; i < messages.length; i++) {
                    let now_time = messages[i]['now_time']
                    let data = new Date()
                    let that_data = new Date(data.getFullYear() + '/' + (data.getMonth() + 1) + '/' + data.getDate() + ' ' + now_time)
                    let raise_time = Number(messages[i]['raise_time'])
                    if (raise_time !== -1) {
                        raise_time = raise_time * 60
                        let time_left = raise_time - Math.floor((data - that_data) / 1000)
                        if (time_left > 0) {
                            messages[i]['seconds_left'] = time_left
                            all_raise_left_time.push(time_left)
                            new_list.push(messages[i])
                        }
                    } else {
                        messages[i]['seconds_left'] = -1
                        all_raise_left_time.push(-1)
                        new_list.push(messages[i])
                    }
                    // console.log(that_data, data)
                }
                // console.log(new_list, all_raise_left_time)
                new_list.sort(function (a, b) {
                    if (a['seconds_left'] === -1 && b['seconds_left'] === -1) {
                        return -1
                    } else if (b['seconds_left'] === -1) {
                        return 1
                    } else if (a['seconds_left'] === -1) {
                        return -1
                    } else {
                        return b['seconds_left'] - a['seconds_left']
                    }
                })
                all_raise_left_time.sort(function (a, b) {
                    if (a === -1 && b === -1) {
                        return -1
                    } else if (b === -1) {
                        return 1
                    } else if (a === -1) {
                        return -1
                    } else {
                        return b - a
                    }
                })
                // console.log(new_list, all_raise_left_time)
                this.all_raise_left_time = all_raise_left_time
                return new_list
            },

            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
            click_raise_btn: function (event, msg) {
                if (this.is_teacher) {
                    // console.log('before', this.temp_outer_id)
                    let outer_id = msg.outer_id
                    let user_id = msg.user_info.user_id
                    this.temp_user_id = user_id
                    if (this.all_forbidden_users) {
                        if (this.all_forbidden_users.includes(Number(user_id))) {
                            this.is_temp_user_forbidden = true
                        } else {
                            this.is_temp_user_forbidden = false
                        }
                    } else {
                        this.is_temp_user_forbidden = false
                    }
                    // for (let i = 0; i < this.channel_users.length; i++){
                    //   if (this.channel_users[i].user_id === user_id){
                    //     this.is_temp_user_forbidden = this.channel_users[i].forbidden
                    //     this.temp_user_id = this.channel_messages[i].user_id
                    //     console.log(this.is_temp_user_forbidden, this.temp_user_id)
                    //   }
                    // }
                    // console.log(outer_id, event.target)
                    this.temp_outer_id = outer_id
                    this.dialogVisible = true
                    // console.log(event.target,outer_id,user_id, this.dialogVisible, 'raise_time')
                }else{
                    // if (event.target.localName === 'img'){
                    //     this.imgDialogVisible = true
                    //     this.imgShow = '<img src="' + event.target.currentSrc + '">'
                    //     this.temp_img_width = String(event.target.naturalWidth / document.body.clientWidth * 100 + 12) + '%'
                    // }
                }
            },
            click_switch_chat_mode: function(){
                if(this.chat_mode){
                    this.chat_mode=false;
                }
                else {
                    this.chat_mode=true;
                }
            },
            click_show_tabbox: function (show) {
                this.show_tabbox = show;
                if (show === 'stick'){
                    this.addBullet2barrageList()
                }else{
                    if (this.bullet_looper){
                        clearInterval(this.bullet_looper)
                        this.bullet_looper = false
                    }
                }
                this.scroll_to_bottom();
            },
            click_dialog_btn: function (event) {
                let type = event.target.getAttribute('data-time')
                this.dialogVisible = false
                if (type === '2') {
                    this.websock.send(JSON.stringify({'raise': {'outer_id': this.temp_outer_id, 'time': type, 'is_left': true}}));
                } else if (type === '1') {
                    this.websock.send(JSON.stringify({'raise': {'outer_id': this.temp_outer_id, 'time': type, 'is_left': false}}));
                } else if (type === '-1') {
                    this.$confirm('是否删除该条消息?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.websock.send(JSON.stringify({'delete_chat_message': this.temp_outer_id}))
                    }).catch(() => {

                    })
                }
                // console.log(type, this.temp_outer_id, 'raise_time')
            },
            click_note_dialog(){
                this.noteDialogVisible = true
                this.note_info_old = this.channel_info.lesson_info.description
                this.note_info = this.channel_info.lesson_info.description
            },
            change_note_info(){
                if (this.note_info.match(/^[ ]*$/)) {
                    this.$message({
                        message: '信息内容不可为空',
                        type: 'warning'
                    });
                    return
                }
                this.noteDialogVisible = false
                this.note_info = this.note_info.trim();
                if (this.note_info !== this.note_info_old) {
                    this.websock.send(JSON.stringify({
                        'note_change': {
                            'note': this.note_info,
                        }
                    }));
                }
            },
            cancel_click_note(){
                this.noteDialogVisible = false
            },
            change_message_dialog_on(message) {
                // console.log(message)
                this.messageDialogVisible = true
                this.temp_change_message = message.message
                this.temp_change_message_old = message
            },
            change_message_dialog_btn: function (is_move) {
                if (this.temp_change_message.match(/^[ ]*$/)) {
                    this.$message({
                        message: '信息内容不可为空',
                        type: 'warning'
                    });
                    return
                }
                // console.log(is_move)
                this.messageDialogVisible = false
                this.temp_change_message = this.temp_change_message.trim();
                // console.log(this.temp_change_message)
                if (this.temp_change_message !== this.temp_change_message_old.message || is_move) {
                    this.websock.send(JSON.stringify({
                        'message_change': {
                            'message_id': this.temp_change_message_old.outer_id,
                            'message': this.temp_change_message,
                            'is_move': is_move,
                        }
                    }));
                }
                this.temp_change_message = ''
                this.temp_change_message_old = ''
            },
            delete_up_message() {
                this.websock.send(JSON.stringify({'delete_up_message': 'delete_up_message', 'message': this.temp_change_message_old}));
                this.temp_change_message = ''
                this.temp_change_message_old = ''
                this.messageDialogVisible = false
            },
            change_subject_name_dialog_on() {
                // console.log(this.active_page)
                this.subjectNameDialogVisible = true
                this.temp_subject_name = this.active_page.subject_name
                this.temp_subject_name_old = this.active_page.subject_name
                this.temp_subject_content = this.active_page.content
                this.temp_subject_content_old = this.active_page.content
                this.temp_subject_id = this.active_page.subject_outer_id
            },
            subject_name_dialog_btn: function () {
                // todo 把修改名字和内容调整到同一次传输（前后台）
                this.subjectNameDialogVisible = false
                if (this.temp_subject_name.match(/^[ ]*$/)) {
                    this.$message({
                        message: '主题名称不可为空',
                        type: 'warning'
                    });
                    return
                }
                if (this.temp_subject_name !== this.temp_subject_name_old) {
                    // console.log(this.temp_subject_name)
                    this.websock.send(JSON.stringify({
                        'subject_name_change': {
                            'subject_id': this.temp_subject_id,
                            'name': this.temp_subject_name
                        }
                    }));
                }
                if (this.temp_subject_content !== this.temp_subject_content_old) {
                    // console.log(this.temp_subject_content)
                    this.websock.send(JSON.stringify({
                        'subject_content_change': {
                            'subject_id': this.temp_subject_id,
                            'content': this.temp_subject_content
                        }
                    }))
                }
                this.temp_subject_content = ''
                this.temp_subject_content_old = ''
                this.temp_subject_name = ''
                this.temp_subject_name_old = ''
                this.temp_subject_id = ''
            },
            change_subject_by_select(subject) {
                // console.log('click subject', subject)
                let lesson_id = this.$route.params.id
                let args = {
                    'lesson_id': lesson_id,
                    'page_id': subject.pages[0].outer_id,
                }
                if (this.is_course_end && !this.is_teacher) {
                    this.set_current_page_and_info_by_page(subject.pages[0].outer_id)
                } else {
                    this.websock.send(JSON.stringify({'change_page': args}));
                }
            },
            change_subject_by_page_index(index) {
                let page_index = Number(index.target.value) - 1
                if (page_index >= 0 && page_index < this.channel_subjects.length) {
                    let lesson_id = this.$route.params.id
                    let args = {
                        'lesson_id': lesson_id,
                        'page_id': this.channel_subjects[page_index]['pages'][0].outer_id,
                    }
                    this.websock.send(JSON.stringify({'change_page': args}));
                }
                index.target.value = ''
            },
            change_subject(type) {
                let this_page_index = -1
                let target_index = -1
                for (let i = 0; i < this.channel_subjects.length; i++) {
                    if (this.channel_subjects[i]['pages'][0]['outer_id'] === this.active_page['outer_id']) {
                        this_page_index = i
                    }
                }
                if (type === 'prev') {
                    if (this_page_index > 0) {
                        target_index = this_page_index - 1
                    }
                } else if (type === 'next') {
                    if (this_page_index !== this.channel_subjects.length - 1) {
                        target_index = this_page_index + 1
                    }
                }
                if (target_index !== -1) {
                    let lesson_id = this.$route.params.id
                    let args = {
                        'lesson_id': lesson_id,
                        'page_id': this.channel_subjects[target_index]['pages'][0].outer_id,
                    }
                    if (this.is_course_end && !this.is_teacher){
                        this.set_current_page_and_info_by_page(this.channel_subjects[target_index]['pages'][0].outer_id)
                    }else{
                        this.websock.send(JSON.stringify({'change_page': args}));
                    }
                }
            },
            set_user_forbidden() {
                if (this.is_temp_user_forbidden) {
                    this.websock.send(JSON.stringify({'set_user_forbidden': {'user_id': this.temp_user_id, 'forbidden': false}}));
                } else {
                    this.websock.send(JSON.stringify({'set_user_forbidden': {'user_id': this.temp_user_id, 'forbidden': true}}));
                }
                this.dialogVisible = false
            },
            delete_subject() {
                if (this.channel_subjects.length <= 1) {
                    this.$message({
                        type: 'warn',
                        message: '不能删除最后一个主题'
                    });
                } else {
                    // console.log('delete', this.temp_subject_id)
                    this.$confirm('是否删除该主题?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.websock.send(JSON.stringify({'delete_subject': {'subject_id': this.temp_subject_id}}));
                    }).catch(() => {

                    })
                }
                this.subjectNameDialogVisible = false
            },
            add_page_with_edit_dialog_on() {
                let subject_name = ''
                let subject_content = ''
                if (this.active_page) {
                    subject_name = this.active_page.subject_name
                    subject_content = this.active_page.content
                }
                this.newSubjectDialogVisible = true
                this.temp_subject_name = subject_name
                this.temp_subject_content = subject_content
            },
            add_page_with_edit(bool) {
                if (bool) {
                    if (this.temp_subject_name.match(/^[ ]*$/)) {
                        this.$message({
                            message: '主题名称不可为空',
                            type: 'warning'
                        });
                        return
                    }
                    this.websock.send(JSON.stringify({
                        'add_page': 'add_page', 'user_id': this.channel_info.user_info.id,
                        'subject_name': this.temp_subject_name, 'subject_content': this.temp_subject_content
                    }));
                }
                this.temp_subject_name = ''
                this.temp_subject_content = ''
                this.newSubjectDialogVisible = false
            },
            clean_temp_info() {
                this.temp_subject_name = ''
                this.temp_subject_content = ''
            },
            add_page() {
                let subject_name = ''
                let subject_content = ''
                for (let i = 0; i < this.channel_subjects.length; i++) {
                    if (this.channel_subjects[i]['outer_id'] === this.active_page['subject_outer_id']) {
                        subject_name = this.channel_subjects[i]['name']
                        subject_content = this.channel_subjects[i]['content']
                    }
                }
                this.$confirm('是否添加主题?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.websock.send(JSON.stringify({
                        'add_page': 'add_page', 'user_id': this.channel_info.user_info.id,
                        'subject_name': subject_name, 'subject_content': subject_content
                    }));
                }).catch(() => {

                })
            },
            get_url_relative_path() {
                var url = window.location.href.toString();
                var arrUrl = url.split("//");

                var start = arrUrl[1].indexOf("/");
                var relUrl = arrUrl[1].substring(start);//stop省略，截取从start开始到结尾的所有字符

                if (relUrl.indexOf("?") != -1) {
                    relUrl = relUrl.split("?")[0];
                }
                return relUrl;
            },
            open_login_page() {
                console.log(this.get_url_relative_path())
                this.change_show_state('on')
                // window.open("/login?redirect=" + encodeURIComponent(this.get_url_relative_path()), "_self");
            },

        }

    }
</script>

<style>
    .welcome-box {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.5);
        z-index: 9999;
    }

    .welcome-box, .welcome-box .welcome {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .welcome-box .welcome {
        width: 320px;
        height: 200px;
        background: #2c2e33;
        border-radius: 8px;
        font-family: PingFang SC;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 45px;
        color: #fff;
    }

    .welcome-box .welcome .text {
        margin-top: 32px;
    }

    .welcome-box .welcome .btn {
        margin: 35px auto;
        color: #00be7b;
        border-radius: 4px;
        font-size: 18px;
        line-height: 25px;
        cursor: pointer;
    }

    .course-learn {
        background: url(/static/img/bg_gray.jpg) repeat 0 0;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
    #course-learn-box{
        margin-left: 33%;

    }
    #course-tool-box{
        /*width: 320px;*/
        /*right: 0;*/
        float: left;
    }

    .course-tool {
        box-shadow: 0px 1px 8px #333;
        position: absolute;
        top: 0;
        bottom: 0;
        overflow: hidden;
        background: #abadb0;
    }

    .cl-title {
        background-position: 0 -124px;
        line-height: 28px;
        font-size: 12px;
    }

    .cl-title .cl-chapter {
        display: inline-block;
        color: #161616;
        width: 65px;
        height: 28px;
        text-align: center;
        float: left;
    }

    .cl-title .cl-lesson {
        width: 41px;
        *width: 45px;
        height: 28px;
        float: left;
        display: inline-block;
        color: #999999;
    }

    .cl-title .cl-lessonnum {
        width: 25px;
        *width: 18px;
        height: 28px;
        color: #161616;
        font-weight: bold;
        display: inline-block;
        float: left;
        text-align: center;
    }

    .cl-title .cl-lessonname {
        padding: 0 0 0 8px;
        display: inline-block;
        float: left;
        color: #cccccc;
    }

    .learn-total {
        bottom: 10px;
        top: 80px;
        left: 10px;
        right: 10px;
        position: absolute;
        z-index: 90;
        box-shadow: 0 1px 5px #303035;
    }

    .learn-box {
        position: absolute;
        width: 100%;
        top: 0;
        bottom: 0px;
        z-index: 101;
        text-align: center;
        overflow: auto;
        background-color: #525050;
    }

    .m-video-box, .m-video-box object, .m-video-box embed, .m-video-box .j-videobox, .m-video-box .j-textbox, .m-text-box, .m-text-box object, .m-text-box embed, .m-text-box .j-videobox, .m-text-box .j-textbox, .m-link-box, .m-link-box object, .m-link-box embed, .m-link-box .j-videobox, .m-link-box .j-textbox {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .ux-cl-reader {
        position: relative;
        height: 100%;
        background: #000;
        overflow: hidden;
    }

    .ux-h5clreader {
        position: relative;
        width: 100%;
        height: 100%;
        background: #fff;
        overflow: hidden;
    }

    .ux-h5clreader_container, .learn-container {
        position: relative;
        width: 100%;
        height: 100%;
        background: #fff;
    }

    .ux-h5clreader_container_viewer, .learn-container-viewer {
        background-color: #fff;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 32px;
        z-index: 1;
    }

    .ux-h5clreader_container_viewer_wrap {
        width: 100%;
        height: 100%;
    }

    .ux-edu-clviewer {
        position: relative;
        width: 100%;
        height: calc(100% - 40px);
        overflow: hidden;
    }

    .ux-edu-main {
        display: block;
        float: left;
        width: 50%;
        height: 100%;
        text-align: left;
        overflow-y: auto;
        padding: 0px 10px 5px 15px;
    }

    .ux-edu-stick {
        width: 50%;
        height: 100%;
        float: right;
        text-align: left;
        overflow-y: auto;
        padding: 10px 15px 5px 10px;
    }

    .active-page-subject {
        font-size: 26px;
        height: 48px;
        padding: 0 15px;
        text-align: left;
    }

    .active-page-subject .text {
        background-color: #663366;
        width: fit-content;
        min-width: 50%;
        padding: 5px 12px;
        color: #fff;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        float: left;
    }

    .active-page-subject .text img {
        position: absolute;
        top: 0;
        right: 0;
        visibility: hidden;
        width: 24px;
        height: 24px;
    }

    .active-page-subject:hover .text img {
        visibility: visible;
    }

    .active-page-subject .tips {
        background-color: #993333;
        width: fit-content;
        min-width: 50px;
        padding: 5px 12px;
        color: #fff;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        float: right;
        text-align: center;
    }

    .active-page-content {
        background-color: #FFFFEE;
        font-style: italic;
        font-size: 16px;
        text-indent: 2em;
        color: #663300;
        padding: 5px;
        margin-left: 10px;
        border-bottom: #663366 2px dashed;
    }

    .viewpoint-item {
        text-indent: 0;
        padding: 5px 5px 0;
        margin: 10px 5px;
        border-bottom: #CCCCCC 2px dotted;
        overflow-wrap: break-word;
        white-space: pre-line;
        position: relative;
    }

    .left-viewpoint .viewpoint-item {
        border-left: #CCCCCC 2px dotted;
    }

    .right-viewpoint .viewpoint-item {
        border-right: #CCCCCC 2px dotted;
    }

    .viewpoint-item.is-teacher:hover {
        background-color: #FFFFEE;
    }

    .viewpoint-item .left-viewpoint-item .img_item, .viewpoint-item .right-viewpoint-item .img_item {
        position: absolute;
        top: 0;
        right: 0;
        visibility: hidden;
        width: 24px;
        height: 24px;
    }

    .viewpoint-item:hover .left-viewpoint-item img, .viewpoint-item:hover .right-viewpoint-item img {
        visibility: visible;
    }

    .viewpoint-avatar {
        background-color: #eee;
        width: 20px;
        height: 20px;
        position: relative;
        border-radius: 50%;
    }

    .viewpoint-avatar:hover {
        border: #663399 2px dotted;
    }

    .left-viewpoint .viewpoint-avatar {
        position: absolute;
        float: left;
        top: 0px;
        left: -10px;
    }

    .right-viewpoint .viewpoint-avatar {
        position: absolute;
        float: right;
        top: 0px;
        right: -10px;
    }

    .left-viewpoint-item {
        margin-left: 10px;
    }

    .right-viewpoint-item {
        margin-right: 10px;
    }

    a.ux-h5clreader_container_bigprev, .ux-h5clreader_container_bignext {
        z-index: 5;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 32px;
        width: 20%;
        background: #fff;
        opacity: 0;
        cursor: url("/static/img/web-prev_cur.ico"), move;
    }

    a.ux-h5clreader_container_bignext {
        right: 0;
        left: auto;
        cursor: url("/static/img/web-next_cur.ico"), move;
    }

    .ux-h5clreader_container_footer {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        background-color: #f5f7fa;
        height: 32px;
        z-index: 9;
    }

    .ux-h5clreader_container_footer_pages {
        position: absolute;
        left: 50%;
        top: 0;
        width: 400px;
        margin-left: -200px;
        height: 32px;
        line-height: 32px;
        color: #666;
        font-size: 12px;
    }

    .ux-h5clreader_container_footer_pages a {
        width: 70px;
        float: left;
        height: 20px;
        line-height: 20px;
        margin: 6px;
        text-align: center;
    }

    .ux-h5clreader_container_footer_pages .page_prev i {
        float: left;
        width: 16px;
        height: 16px;
        margin: 2px;
        background: url("/static/img/icons_toolbar.png");
        background-position: -16px 0;
    }

    .ux-h5clreader_container_footer_pages_in {
        float: left;
        background: #3E3F49;
        border-radius: 10px;
        width: 32px;
        height: 20px;
        line-height: 20px;
        margin: 6px;
        text-align: center;
        color: #fff;
    }

    .ux-h5clreader_container_footer_pages_total {
        float: left;
    }

    .ux-h5clreader_container_footer_pages .page_list {
        width: 100px;
        background: #3E3F49;
        border-radius: 10px;
        color: #fff;
    }

    .ux-h5clreader_container_footer_pages .page_next i {
        float: left;
        width: 16px;
        height: 16px;
        margin: 2px;
        background: url("/static/img/icons_toolbar.png");
        background-position: -16px -16px;
    }

    .ux-h5clreader_container_footer_pages .page_add i {
        float: left;
        width: 16px;
        height: 16px;
        margin: 2px;
        background: url("/static/img/icons_toolbar.png");
        background-position: -32px -48px;
    }

    .ux-h5clreader_container_footer_pages_change {
        float: left;
        background: #3E3F49;
        border-radius: 10px;
        width: 100px;
        height: 20px;
        line-height: 20px;
        margin: 6px;
        text-align: center;
        color: white;
    }

    .m-ctb .courseintro {
        height: 72px;
        padding: 10px 15px;
        background: #abadb0;
    }

    .m-ctb .courseTitle {
        overflow: hidden;
        width: calc(100% - 52px);
    }

    .courseImg-link {
        text-align: center;
        align-items: center;
        position: absolute;
        right: 15px;
        width: 50px;
    }

    .m-ctb .courseImgCover img {
        position: absolute;
        height: 40px;
        width: 40px;
        border-radius: 50%;
        align-items: center;
        display: flex;
    }

    .m-ctb .courseImgCover a {
        position: absolute;
        top: 40px;
        font-size: xx-small;
        align-items: center;
        display: flex;
    }


    .u-coursetitle {
        width: 235px;
        text-align: left;
        line-height: 19px;
        color: #fff;
        font-size: 12px;
        text-align: left;
        overflow: hidden;
    }

    .f-fl {
        float: left;
    }

    .u-coursetitle a {
        font-size: 15px;
        display: block;
        color: #333;
    }

    .f-thide {
        font-size: 18px;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        -ms-text-overflow: ellipsis;
    }

    .f-thide-small-font {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        -ms-text-overflow: ellipsis;
        font-size: xx-small;
    }

    .u-coursetitle p {
        color: #666;
    }

    .m-ctb .tabs {
        height: 45px;
        background: url(/static/img/bg_toolbar.png) repeat-x;
        background-color: #f5f7fa;
        font-family: '微软雅黑';
    }

    .coursesprite, .m-tb-notes .notenav .navItem.currentDisable, .m-ctb .tabicon, .m-courselearn .cs-btn, .m-courselearn .cs-up, .m-courselearn .cs-down, .m-courselb .cl-back, .m-courselb .cl-pre, .m-courselb .cl-next, .m-courselb .cl-title, .cl-info .clis span, .cl-info em.finish, .cl-info em.unfinish, .cli-base span, .course-refer .refer-item .cr-load, .course-refer .refer-item .cr-share, .u-hiderightbtn {
        background: url(/static/img/btn_bg_course_learn.png) no-repeat 4449px 4449px;
    }

    .m-ctb .tabitem {
        float: left;
        height: 44px;
        width: 33%;
        text-align: center;
        line-height: 44px;
        color: #666;
    }

    .m-ctb .tabicon {
        margin: 15px 5px 0 calc(50% - 28px);
    }

    .m-ctb .active {
        color: #fff;
        background: url(/static/img/btn_pos_tab_bg.png) 50% no-repeat;
    }

    .m-ctb .tabicon-0 {
        width: 15px;
        height: 15px;
        background-position: -98px -662px;
    }

    .m-ctb .tabicon-1 {
        width: 15px;
        height: 15px;
        background-position: -98px -639px;
    }

    .m-ctb .tabicon-2 {
        width: 15px;
        height: 16px;
        background-position: -40px -639px;
    }

    .m-ctb .tabicon-3 {
        width: 15px;
        height: 15px;
        background-position: -40px -689px;
    }

    .m-ctb .tabicon-4 {
        width: 15px;
        height: 16px;
        background-position: -40px -664px;
    }

    .m-ctb .active .tabicon-0 {
        width: 16px;
        height: 15px;
        background-position: -122px -662px;
    }

    .m-ctb .active .tabicon-1 {
        width: 16px;
        height: 15px;
        background-position: -122px -639px;
    }

    .m-ctb .active .tabicon-2 {
        width: 16px;
        height: 15px;
        background-position: -60px -639px;
    }

    .m-ctb .active .tabicon-3 {
        width: 16px;
        height: 15px;
        background-position: -60px -689px;
    }

    .m-ctb .active .tabicon-4 {
        width: 16px;
        height: 15px;
        background-position: -60px -664px;
    }

    .cl-info {
        background: #000;
        height: 36px;
        line-height: 36px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 102;
        padding-left: 12px;
    }

    .cl-info a {
        font-size: 13px;
        color: #fff;
        display: block;
    }

    .cli-base {
        padding: 0 10px;
        cursor: pointer;
        float: left;
        color: #fff;
    }

    .cli-intro span {
        background-position: 0 0px;
    }

    .cli-base span {
        padding-left: 20px;
    }

    .cli-app .u-qrcode {
        width: 76px;
        height: 36px;
        position: absolute;
        top: 0;
        left: 0;
        background: none;
    }

    .cl-info a {
        font-size: 13px;
        color: #fff;
        display: block;
    }

    .u-qrcode:hover .all {
        display: block;
    }

    .cli-app .u-qrcode .all {
        bottom: 40px;
    }

    .u-qrcode .all {
        display: none;
        cursor: default;
        position: absolute;
        width: 120px;
        height: 170px;
        padding: 10px;
        right: 0px;
        bottom: 65px;
        background: #fff;
        border: 1px solid #ddd;
    }

    .u-qrcode:hover {
        background-position: -71px -112px;
    }

    .cli-base:hover, .cli-base.cli-cover {
        background: #252525;
    }

    a.f-fc0:hover, a:hover .f-fc0, a.f-fc3:hover, a:hover .f-fc3, a.f-fc6:hover, a:hover .f-fc6, a.f-fc9:hover, a:hover .f-fc9, a.f-fcf:hover, a:hover .f-fcf {
        color: #39a030;
        text-decoration: none;
    }

    .cl-info a:hover {
        font-size: 13px;
        color: #fff;
        display: block;
    }

    .cl-info em.unfinish {
        background-position: -4px -556px;
        margin: 5px 5px 0 0;
        float: right;
        width: 70px;
        height: 25px;
        cursor: pointer;
    }

    .cl-info .clis {
        margin-right: 20px;
    }

    .f-fr {
        float: right;
    }

    .m-ctb .tabarea {
        position: absolute;
        top: 116px;
        left: 0;
        width: 100%;
        bottom: 0;
        overflow: hidden;
        background: #f5f7fa;
    }

    .m-ctb .tabarea .tabbox {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .m-toolbar-forum {
        height: 100%;
        display: block;
    }

    .m-toolbar-forum .posts-forum {
        height: calc(100% - 152px);
        top: 140px;
        overflow: auto;
    }
    .m-toolbar-forum .posts-forum_emoji {
        height: calc(100% - 236px);
        top: 140px;
        overflow: auto;
    }

    .m-toolbar-forum .posts-intro {
        height: calc(100% - 40px);
        padding-bottom: 0;
        top: 140px;
        overflow: auto;
    }

    .m-toolbar-forum .posts-stick {
        height: calc(100%);
        padding-bottom: 0px;
        top: 140px;
        overflow: auto;
    }

    .m-toolbar-forum .posts-stick::after {
        display: block;
        height: 150px;
        content: '';
        visibility: hidden;
    }

    .m-toolbar-forum .bullet-container {
        position: absolute;
        overflow: hidden;
        height: 150px;
        width: 100%;
        bottom: 0;
    }

    .bullet-container {
        background-image: -webkit-linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0) 0%,
                rgba(0, 0, 0, 0.1) 30%,
                rgba(0, 0, 0, 0.2) 50%,
                rgba(0, 0, 0, 0.3) 70%,
                rgba(0, 0, 0, 0.5) 85%,
                rgba(0, 0, 0, 0.6) 90%,
                rgba(0, 0, 0, 0.9) 100%);
        background-image: linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0) 0%,
                rgba(0, 0, 0, 0.1) 30%,
                rgba(0, 0, 0, 0.2) 50%,
                rgba(0, 0, 0, 0.3) 70%,
                rgba(0, 0, 0, 0.5) 85%,
                rgba(0, 0, 0, 0.6) 90%,
                rgba(0, 0, 0, 0.9) 100%);
    }

    .bullet-container .button_area {
        position: absolute;
        color: #fff;
        width: 100%;
        bottom: 0;
        height: 34px;
        padding: 0 5px;
        z-index: 9999;
    }

    .bullet-container .button_area span {
        font-size: x-small;
    }

    .m-toolbar-forum .posts .u-forumli {
        padding: 0 10px;
    }

    .u-forumli {
        cursor: pointer;
        padding: 0 20px;
        font-size: 12px;
    }

    .m-toolbar-forum .test_area {
        width: 100%;
        height: 108px;
        outline: none;
        resize: none;
        border: 1px solid #eee;
    }

    .buttonsprite, .m-edititem .editopt a.editbtn, .m-edititem .editopt a.editbtn span, .m-tb-notes .mask .joincourse, .m-tb-notes .mask .joincourse span, .u-coursePlanPayMsg .cancelBtn, .u-coursePlanPayMsg .cancelBtn span, .m-videoReportDialog .btns .okbtn, .m-videoReportDialog .btns .okbtn span, .m-videoReportDialog .btns .cancelbtn, .m-videoReportDialog .btns .cancelbtn span, .m-feedbackSys .btn, .m-feedbackSys .btn span, .m-toolbar-forum .edit .postBtn, .m-toolbar-forum .edit .postBtn span, .m-lastframe .nextOrestimate, .m-lastframe .nextOrestimate span, .m-mostAsk .editctrl .submitBtn, .m-mostAsk .editctrl .submitBtn span, .m-mostAsk .mask .joincourse, .m-mostAsk .mask .joincourse span, .u-clgrowl .loginBtn, .u-clgrowl .loginBtn span, .m-predlog .findBtn, .m-predlog .findBtn span, .m-predlog .loginBtn, .m-predlog .loginBtn span {
        background: url(/static/img/bg_btn_green.png) no-repeat 4449px 4449px;
    }

    .m-toolbar-forum .edit {
        background-color: #fff;
    }

    .m-toolbar-forum .button_area {
        height: 34px;
        padding: 0 5px;
    }

    .m-toolbar-forum .button_area span {
        font-size: x-small;
    }

    .m-toolbar-forum .edit span {
        line-height: 32px;
    }

    .m-toolbar-forum .edit .postBtn {
        margin: 0 5px;
        display: block;
        text-decoration: none;
        background-position: 68px 0px;
    }

    .m-toolbar-forum .edit .postBtn span {
        display: block;
        text-align: center;
        padding: 0 10px;
        width: 58px;
        font-size: 12px;
        height: 34px;
        line-height: 33px;
        color: #fff;
        background-position: -40px 0px;
    }

    .show_course_header {
        height: 72px;
    }
    .icon_slot{
        cursor: pointer;
        width: 25px;
        align-items: center;
        text-align: center;
        display: inline-block;
    }
    .emoji{
        background: url(/static/img/emoji.png) top left no-repeat;
        background-position-x: left;
        background-position-y: top;
        width: 20px;
        height: 20px;
        display: -moz-inline-stack;
        display: inline-block;
        vertical-align: top;
        zoom: 1;
        *display: inline;
    }
    .emoji1f61c {
        background-position: -0px -12200px;
    }
    .pic-list-icon{
        font-size: 30px;
        border:1px dashed #adadad;
    }
    .pic-list-div{
        position: relative;
        padding-left:2px;
        margin-bottom: 5px;
        display: inline-flex;
        align-items: center;
        text-align: center;
    }
    .pic-list-del{
        position: absolute;
        right: 0px;
        top:0px;
    }
    .pic-slot{
        width: 30px;
        height: 30px;
        cursor: default;
    }
    .message_box {
        height: 100%;
        overflow-y: scroll;
        /*background: #fff;*/
    }

    .item {
        -webkit-column-break-inside: avoid;
        -moz-column-break-inside: avoid;
        break-inside: avoid;
        /*border-top: 1px solid #eee;*/
        position: relative;
        min-height: 20px;
        display: flow-root;
        /* background: #fff; */
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .item_header {
        width: 52px;
        height: 60px;
        border-radius: 50%;
        margin: 0;
        float: left;
        font-size: 12px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        text-align: center;
    }

    .item_header_self {
        width: 52px;
        height: 60px;
        border-radius: 50%;
        margin: 0;
        float: right;
        font-size: 12px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        text-align: center;
    }

    .item_header img, .item_header_self img {
        margin: 3px 6px 0;
        width: 40px;
        height: 40px;
    }

    .icon-chat-mode{
        position: absolute;
        width: 22px;
        height: 22px;
        right: 0;
        top: 0;
    }

    .icon-chat-mode img{
        width: 100%;
        cursor: pointer;
    }

    .avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 10px;
        padding-bottom: 1px;
        padding-top: 1px;
    }

    .item_content {
        width: auto;
        word-break: break-all;
        background: #eeeeee;
        padding: 5px 10px;
        margin: 4px;
        line-height: 20px;
        font-size: 14px;
        border-radius: 10px;
        position: relative;
        float: left;
        max-width: calc(100% - 90px);
        min-height: 38px;
        overflow-wrap: break-word;
        white-space: pre-line;
    }

    .intro_content {
        width: auto;
        word-break: break-all;
        padding: 5px 10px;
        margin: 4px;
        font-size: 14px;
        min-height: 38px;
        overflow-wrap: break-word;
        white-space: pre-line;
    }

    .item_content_self {
        width: auto;
        word-break: break-all;
        background: #66ee41;
        padding: 5px 10px;
        margin: 4px;
        line-height: 20px;
        font-size: 14px;
        border-radius: 10px;
        position: relative;
        float: right;
        max-width: calc(100% - 90px);
        min-height: 38px;
        overflow-wrap: break-word;
        white-space: pre-line;
    }

    .item_side_img_right {
        /*background: url("/static/img/bg_chat_r.png") no-repeat 20px 20px;*/
        position: absolute;
        left: 100%;
        top: 8px;
        width: 8px;
        height: 14px;
    }

    .item_side_img_left {
        position: absolute;
        right: 100%;
        top: 8px;
        width: 8px;
        height: 14px;
    }

    .item-stick-act {
        top: 0px;
        width: 16px;
        height: 20px;
        position: absolute;
        overflow: hidden;
        visibility: hidden;
    }

    .item-stick-act.left {
        left: 100%;
    }

    .item-stick-act.right {
        right: 100%;
    }

    .item_content:hover img, .item_content_self:hover img {
        visibility: visible;
    }

    .not_show {
        display: none;
    }

    .course_header_bar_div {
        width: 100%;
        /*height: 72px;*/
        background: #333;
        padding: 6px 0 0 20px;
        color: #fff;
        transition: opacity 1s;
        z-index: 8;
    }

    .course_header_bar_layout_div {
        margin: auto;
        width: 50%;
        float: left;
    }

    .course_header_bar_layout_right_div {
        margin: auto;
        width: 50%;
        float: right;
    }

    .course_header_bar_course_title {
        font-size: 22px;
        line-height: 1.6;
        font-weight: 500;
    }

    .course_header_bar_course_info_bottom {
        font-size: 14px;
        margin-left: 10px;
    }

    .span_split:before {
        content: "";
        background: #eee;
        width: 1px;
        height: 20px;
        display: inline-block;
        margin: 0 8px -4px 4px;
    }

    .dialog_btn {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #FFF;
        border: 1px solid #DCDFE6;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        -webkit-transition: .1s;
        transition: .1s;
        font-weight: 500;
        padding: 12px 20px;
        font-size: 14px;
        border-radius: 4px;
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .dialog_text {
        width: 100%;
        height: 150px;
    }

    .dialog_text_small {
        width: 100%;
        height: 70px;
    }

    .dialog_input_div {
        margin: auto;
        width: 80%
    }

    .active_page_subject {
        color: black;
        font-size: larger;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        -ms-text-overflow: ellipsis;
    }

    .baberrageStyle {
        display: flex;
        flex-direction: column;
    }

    .baberrageStyle span {
        color: #FFF;
    }

    .baberrage-stage {
        top: 0;
        z-index: 5;
    }

    .baberrage-stage .baberrage-item.normal {
        color: #FFF;
    }
    .player-icon{
        cursor: pointer;
        width: 50px;
        height: 30px;
        padding-left: 10px;
    }

</style>